import React, { Component } from 'react';
import { Container, Row, Col, Card, Button } from 'reactstrap';



class ClusterDiagram extends Component {
  render() {
    return (

      <div>

      <>
      <div className="panels" id="publish_page_container">
      <div
      id="published_infographic_container"
      style={{ height: "717.636px", overflowX: "hidden" }}
      >
      <div
      id="published_infographic"
      style={{
        margin: "0px auto",
        background: "rgb(29, 40, 56)",
        width: 1056,
        height: 816,
        transform: "scale(0.818182)",
        transformOrigin: "0px 0px 0px",
        boxSizing: "content-box",
        border: "2px solid rgb(224, 224, 224)"
      }}
      >
      <div
        id="WidgetLayer"
        style={{ width: "100%", height: "100%", position: "absolute" }}
      >
        <div className="styles__canvas--2Mea1" style={{ width: "100%" }}>
          <div
            data-id="widgetCanvas"
            className="styles__canvasWidgets--7JykM"
            style={{ width: "100%", height: "100%" }}
          >
            <div />
          </div>
        </div>
      </div>
      <div id="widget_container" style={{ boxSizing: "border-box" }}>
        <div style={{ width: 1056, height: 816 }}>
          <div
            className="ui-draggable ui-draggable-handle ui-selectable v-ui-guidedable v-widget-selectable disabled"
            style={{
              position: "absolute",
              left: 51,
              top: 717,
              transform: "rotate(0rad)",
              cursor: "auto",
              width: 954,
              height: 16,
              zIndex: 0
            }}
          >
            <div style={{ display: "block" }}>
              <div>
                <svg
                  height={16}
                  version="1.1"
                  width={954}
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ overflow: "hidden", position: "absolute" }}
                >
                  <desc
                    style={{ WebkitTapHighlightColor: "rgba(0, 0, 0, 0)" }}
                  >
                    Created with Raphaël 2.1.2
                  </desc>
                  <defs
                    style={{ WebkitTapHighlightColor: "rgba(0, 0, 0, 0)" }}
                  />
                  <rect
                    x={0}
                    y={7}
                    width={954}
                    height={3}
                    r={0}
                    rx={0}
                    ry={0}
                    fill="#ffffff"
                    stroke="none"
                    style={{ WebkitTapHighlightColor: "rgba(0, 0, 0, 0)" }}
                  />
                </svg>
              </div>
            </div>
          </div>
          <div
            className="ui-draggable ui-draggable-handle ui-selectable v-ui-guidedable v-widget-selectable disabled"
            style={{
              position: "absolute",
              left: "79.0469px",
              top: 746,
              width: 162,
              height: 25,
              transform: "rotate(0rad)",
              cursor: "auto",
              zIndex: 0
            }}
          >
            <div>
              <div
                id="draftEditor-f6f5635b-50cc-4c5d-9155-ae1a619000c8"
                className="styles__cleanCssRoot--SYmyP"
                style={{ textAlign: "left" }}
              >
                <div className="DraftEditor-root">
                  <div
                    className="DraftEditor-editorContainer"
                    style={{ position: "initial" }}
                  >
                    <div
                      aria-describedby="placeholder-3pkba"
                      className="public-DraftEditor-content"
                      contentEditable="false"
                      spellCheck="true"
                      style={{
                        outline: "none",
                        userSelect: "text",
                        whiteSpace: "pre-wrap",
                        overflowWrap: "break-word"
                      }}
                    >
                      <div data-contents="true">
                        <div
                          className="draftjs-textalign-left"
                          data-block="true"
                          data-editor="3pkba"
                          data-offset-key="default-0-0"
                          style={{
                            fontFamily: "Poppins",
                            fontSize: 50,
                            color: "rgb(51, 51, 51)",
                            lineHeight: "1.2"
                          }}
                        >
                          <div
                            data-offset-key="default-0-0"
                            className="public-DraftStyleDefault-block public-DraftStyleDefault-ltr"
                          >
                            <span
                              data-offset-key="default-0-0"
                              style={{
                                fontWeight: "normal",
                                fontStyle: "normal"
                              }}
                            >
                              <br data-text="true" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="ui-draggable ui-draggable-handle ui-selectable v-ui-guidedable v-widget-selectable disabled"
            style={{
              position: "absolute",
              left: 671,
              top: 746,
              width: 334,
              height: 25,
              transform: "rotate(0rad)",
              cursor: "auto",
              zIndex: 0
            }}
          >
            <div>
              <div
                id="draftEditor-2ba69b40-9ad2-4733-93df-c4fd404ddaa4"
                className="styles__cleanCssRoot--SYmyP"
                style={{ textAlign: "right" }}
              >
                <div className="DraftEditor-root">
                  <div
                    className="DraftEditor-editorContainer"
                    style={{ position: "initial" }}
                  >
                    <div
                      aria-describedby="placeholder-2elg8"
                      className="public-DraftEditor-content"
                      contentEditable="false"
                      spellCheck="true"
                      style={{
                        outline: "none",
                        userSelect: "text",
                        whiteSpace: "pre-wrap",
                        overflowWrap: "break-word"
                      }}
                    >
                      <div data-contents="true">
                        <div
                          className="draftjs-textalign-right"
                          data-block="true"
                          data-editor="2elg8"
                          data-offset-key="default-0-0"
                          style={{
                            fontFamily: '"Barlow Condensed"',
                            fontSize: 23,
                            color: "rgb(255, 255, 255)",
                            lineHeight: "1.1"
                          }}
                        >
                          <div
                            data-offset-key="default-0-0"
                            className="public-DraftStyleDefault-block public-DraftStyleDefault-ltr"
                          >
                            <span
                              data-offset-key="default-0-0"
                              style={{
                                fontFamily: '"Barlow Condensed"',
                                fontSize: 23,
                                lineHeight: "1.1",
                                color: "rgb(255, 255, 255)",
                                fontWeight: "normal",
                                fontStyle: "normal"
                              }}
                            >

                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="ui-draggable ui-draggable-handle ui-selectable v-ui-guidedable v-widget-selectable disabled"
            data-author="Icon Designed By Icons8"
            style={{
              position: "absolute",
              left: 50,
              top: 746,
              width: "23.0769px",
              height: 25,
              transform: "rotate(0rad)",
              cursor: "auto",
              zIndex: 0
            }}
          >
            <div style={{ display: "block" }}>
              <div>
                <div
                  style={{
                    width: "23.0769px",
                    height: 25,
                    position: "relative"
                  }}
                >
                  <div
                    style={{
                      overflow: "hidden",
                      position: "absolute",
                      top: 0,
                      width: "23.0769px",
                      height: 0
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="4 3 24 26"
                      fill="rgba(246,77,42,1)"
                      style={{
                        width: "23.0769px",
                        height: 25,
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        position: "absolute",
                        top: 0,
                        left: 0
                      }}
                    >
                      <path
                        style={{
                          textIndent: 0,
                          textAlign: "start",
                          lineHeight: "normal",
                          textTransform: "none",
                          blockProgression: "tb",
                          InkscapeFontSpecification: "Bitstream Vera Sans"
                        }}
                        d="M 4 3 L 4 4 L 4 28 L 4 29 L 5 29 L 14 29 L 15 29 L 15 28 L 15 25 L 17 25 L 17 28 L 17 29 L 18 29 L 27 29 L 28 29 L 28 28 L 28 4 L 28 3 L 27 3 L 5 3 L 4 3 z M 6 5 L 26 5 L 26 27 L 19 27 L 19 24 L 19 23 L 18 23 L 14 23 L 13 23 L 13 24 L 13 27 L 6 27 L 6 5 z M 8 7 L 8 9 L 12 9 L 12 7 L 8 7 z M 14 7 L 14 9 L 18 9 L 18 7 L 14 7 z M 20 7 L 20 9 L 24 9 L 24 7 L 20 7 z M 8 11 L 8 13 L 12 13 L 12 11 L 8 11 z M 14 11 L 14 13 L 18 13 L 18 11 L 14 11 z M 20 11 L 20 13 L 24 13 L 24 11 L 20 11 z M 8 15 L 8 17 L 12 17 L 12 15 L 8 15 z M 14 15 L 14 17 L 18 17 L 18 15 L 14 15 z M 20 15 L 20 17 L 24 17 L 24 15 L 20 15 z M 8 19 L 8 21 L 12 21 L 12 19 L 8 19 z M 14 19 L 14 21 L 18 21 L 18 19 L 14 19 z M 20 19 L 20 21 L 24 21 L 24 19 L 20 19 z M 8 23 L 8 25 L 12 25 L 12 23 L 8 23 z M 20 23 L 20 25 L 24 25 L 24 23 L 20 23 z"
                      />
                    </svg>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div
            data-id="3ee22676-0d09-46ca-acc8-59af1ae3a431"
            data-diagram-type="circular-mindmap"
            className="contentDraggable styles__diagram--2KtNx styles__pointerEventsDisabled--3r2MB"
          >
            <svg
              data-id="3ee22676-0d09-46ca-acc8-59af1ae3a431_edges"
              className="styles__pointerEventsDisabled--3r2MB"
              style={{ position: "absolute", width: "100%", height: "100%" }}
            >
              <path
                data-id="edge_2i--xqlxfk"
                d="M 528.01047162717 125.70194805031 l 177.99358609488002 -0.6935085364099933"
                stroke="rgb(255, 255, 255)"
                strokeWidth={3}
                strokeLinecap="round"
                fill="none"
                strokeDasharray="none"
                className="styles__pointerEventsDisabled--3r2MB"
              />
              <path
                className="styles__pointerEventsDisabled--3r2MB ignore-jqueryui-selectable vg-mouse-interactive"
                d="M 528.01047162717 125.70194805031 l 177.99358609488002 -0.6935085364099933"
                stroke="transparent"
                strokeWidth={8}
                strokeLinecap="round"
                fill="transparent"
                data-vg-test-label="smart-edge-0"
                style={{ pointerEvents: "auto" }}
              />
              <path
                data-id="edge_PgDUX4Jn2U"
                d="M 706.00405772205 125.0084395139 l 161.59135066755994 -0.22008228097799076"
                stroke="rgb(255, 255, 255)"
                strokeWidth={3}
                strokeLinecap="round"
                fill="none"
                strokeDasharray="none"
                className="styles__pointerEventsDisabled--3r2MB"
              />
              <path
                className="styles__pointerEventsDisabled--3r2MB ignore-jqueryui-selectable vg-mouse-interactive"
                d="M 706.00405772205 125.0084395139 l 161.59135066755994 -0.22008228097799076"
                stroke="transparent"
                strokeWidth={8}
                strokeLinecap="round"
                fill="transparent"
                data-vg-test-label="smart-edge-1"
                style={{ pointerEvents: "auto" }}
              />
              <path
                data-id="edge_lKd6GJUPkV"
                d="M 528.01047162717 125.70194805031 l 228.49347450146 158.80076130547"
                stroke="rgb(255, 255, 255)"
                strokeWidth={3}
                strokeLinecap="round"
                fill="none"
                strokeDasharray="none"
                className="styles__pointerEventsDisabled--3r2MB"
              />
              <path
                className="styles__pointerEventsDisabled--3r2MB ignore-jqueryui-selectable vg-mouse-interactive"
                d="M 528.01047162717 125.70194805031 l 228.49347450146 158.80076130547"
                stroke="transparent"
                strokeWidth={8}
                strokeLinecap="round"
                fill="transparent"
                data-vg-test-label="smart-edge-2"
                style={{ pointerEvents: "auto" }}
              />
              <path
                data-id="edge_HKswwO0x8-"
                d="M 528.01047162717 125.70194805031 l -174.99809621813 -0.6990183020119929"
                stroke="rgb(255, 255, 255)"
                strokeWidth={3}
                strokeLinecap="round"
                fill="none"
                strokeDasharray="none"
                className="styles__pointerEventsDisabled--3r2MB"
              />
              <path
                className="styles__pointerEventsDisabled--3r2MB ignore-jqueryui-selectable vg-mouse-interactive"
                d="M 528.01047162717 125.70194805031 l -174.99809621813 -0.6990183020119929"
                stroke="transparent"
                strokeWidth={8}
                strokeLinecap="round"
                fill="transparent"
                data-vg-test-label="smart-edge-3"
                style={{ pointerEvents: "auto" }}
              />
              <path
                data-id="edge__7bqNWMSu2"
                d="M 528.01047162717 125.70194805031 l -298.50226465189996 159.80027600688"
                stroke="rgb(255, 255, 255)"
                strokeWidth={3}
                strokeLinecap="round"
                fill="none"
                strokeDasharray="none"
                className="styles__pointerEventsDisabled--3r2MB"
              />
              <path
                className="styles__pointerEventsDisabled--3r2MB ignore-jqueryui-selectable vg-mouse-interactive"
                d="M 528.01047162717 125.70194805031 l -298.50226465189996 159.80027600688"
                stroke="transparent"
                strokeWidth={8}
                strokeLinecap="round"
                fill="transparent"
                data-vg-test-label="smart-edge-4"
                style={{ pointerEvents: "auto" }}
              />
              <path
                data-id="edge_aSkFL73SzS"
                d="M 528.01047162717 125.70194805031 l -0.5052332573399099 192.79917090028002"
                stroke="rgb(255, 255, 255)"
                strokeWidth={3}
                strokeLinecap="round"
                fill="none"
                strokeDasharray="none"
                className="styles__pointerEventsDisabled--3r2MB"
              />
              <path
                className="styles__pointerEventsDisabled--3r2MB ignore-jqueryui-selectable vg-mouse-interactive"
                d="M 528.01047162717 125.70194805031 l -0.5052332573399099 192.79917090028002"
                stroke="transparent"
                strokeWidth={8}
                strokeLinecap="round"
                fill="transparent"
                data-vg-test-label="smart-edge-5"
                style={{ pointerEvents: "auto" }}
              />
              <path
                data-id="edge_efkic7NkQf"
                d="M 527.5052383698301 318.50111895059 l 0.0015363849299774301 149.99941854230997"
                stroke="rgb(245, 130, 31)"
                strokeWidth={3}
                strokeLinecap="round"
                fill="none"
                strokeDasharray="none"
                className="styles__pointerEventsDisabled--3r2MB"
              />
              <path
                className="styles__pointerEventsDisabled--3r2MB ignore-jqueryui-selectable vg-mouse-interactive"
                d="M 527.5052383698301 318.50111895059 l 0.0015363849299774301 149.99941854230997"
                stroke="transparent"
                strokeWidth={8}
                strokeLinecap="round"
                fill="transparent"
                data-vg-test-label="smart-edge-6"
                style={{ pointerEvents: "auto" }}
              />
              <path
                data-id="edge_71buWHrxUl"
                d="M 527.50677475476 468.5005374929 l -116.48679528831002 146.43158497603997"
                stroke="rgb(245, 130, 31)"
                strokeWidth={3}
                strokeLinecap="round"
                fill="none"
                strokeDasharray="none"
                className="styles__pointerEventsDisabled--3r2MB"
              />
              <path
                className="styles__pointerEventsDisabled--3r2MB ignore-jqueryui-selectable vg-mouse-interactive"
                d="M 527.50677475476 468.5005374929 l -116.48679528831002 146.43158497603997"
                stroke="transparent"
                strokeWidth={8}
                strokeLinecap="round"
                fill="transparent"
                data-vg-test-label="smart-edge-7"
                style={{ pointerEvents: "auto" }}
              />
              <path
                data-id="edge_5522v18JbJ"
                d="M 527.50677475476 468.5005374929 l 2.279239854259913 146.43252634772"
                stroke="rgb(245, 130, 31)"
                strokeWidth={3}
                strokeLinecap="round"
                fill="none"
                strokeDasharray="none"
                className="styles__pointerEventsDisabled--3r2MB"
              />
              <path
                className="styles__pointerEventsDisabled--3r2MB ignore-jqueryui-selectable vg-mouse-interactive"
                d="M 527.50677475476 468.5005374929 l 2.279239854259913 146.43252634772"
                stroke="transparent"
                strokeWidth={8}
                strokeLinecap="round"
                fill="transparent"
                data-vg-test-label="smart-edge-8"
                style={{ pointerEvents: "auto" }}
              />
              <path
                data-id="edge_z46ZYB6Bdm"
                d="M 527.50677475476 468.5005374929 l 123.09714292106992 146.43324212836"
                stroke="rgb(245, 130, 31)"
                strokeWidth={3}
                strokeLinecap="round"
                fill="none"
                strokeDasharray="none"
                className="styles__pointerEventsDisabled--3r2MB"
              />
              <path
                className="styles__pointerEventsDisabled--3r2MB ignore-jqueryui-selectable vg-mouse-interactive"
                d="M 527.50677475476 468.5005374929 l 123.09714292106992 146.43324212836"
                stroke="transparent"
                strokeWidth={8}
                strokeLinecap="round"
                fill="transparent"
                data-vg-test-label="smart-edge-9"
                style={{ pointerEvents: "auto" }}
              />
              <path
                data-id="edge_6zqrBtgGyX"
                d="M 353.01237540904 125.002929748298 l -167.36351311166996 3.259443460591015"
                stroke="rgb(255, 255, 255)"
                strokeWidth={3}
                strokeLinecap="round"
                fill="none"
                strokeDasharray="none"
                className="styles__pointerEventsDisabled--3r2MB"
              />
              <path
                className="styles__pointerEventsDisabled--3r2MB ignore-jqueryui-selectable vg-mouse-interactive"
                d="M 353.01237540904 125.002929748298 l -167.36351311166996 3.259443460591015"
                stroke="transparent"
                strokeWidth={8}
                strokeLinecap="round"
                fill="transparent"
                data-vg-test-label="smart-edge-10"
                style={{ pointerEvents: "auto" }}
              />
              <path
                data-id="edge_M2jgHHNocn"
                d="M 229.50820697527 285.50222405719 l -175.3740727148482 65.88929455774002"
                stroke="rgb(104, 42, 141)"
                strokeWidth={3}
                strokeLinecap="round"
                fill="none"
                strokeDasharray="none"
                className="styles__pointerEventsDisabled--3r2MB"
              />
              <path
                className="styles__pointerEventsDisabled--3r2MB ignore-jqueryui-selectable vg-mouse-interactive"
                d="M 229.50820697527 285.50222405719 l -175.3740727148482 65.88929455774002"
                stroke="transparent"
                strokeWidth={8}
                strokeLinecap="round"
                fill="transparent"
                data-vg-test-label="smart-edge-11"
                style={{ pointerEvents: "auto" }}
              />
              <path
                data-id="edge_fmVl7xJN41"
                d="M 527.50677475476 468.5005374929 l -236.09499675595004 146.42967823857998"
                stroke="rgb(245, 130, 31)"
                strokeWidth={3}
                strokeLinecap="round"
                fill="none"
                strokeDasharray="none"
                className="styles__pointerEventsDisabled--3r2MB"
              />
              <path
                className="styles__pointerEventsDisabled--3r2MB ignore-jqueryui-selectable vg-mouse-interactive"
                d="M 527.50677475476 468.5005374929 l -236.09499675595004 146.42967823857998"
                stroke="transparent"
                strokeWidth={8}
                strokeLinecap="round"
                fill="transparent"
                data-vg-test-label="smart-edge-12"
                style={{ pointerEvents: "auto" }}
              />
              <path
                data-id="edge_65KPHAgP7h"
                d="M 229.50820697527 285.50222405719 l -152.343331837932 173.27041780496"
                stroke="rgb(104, 42, 141)"
                strokeWidth={3}
                strokeLinecap="round"
                fill="none"
                strokeDasharray="none"
                className="styles__pointerEventsDisabled--3r2MB"
              />
              <path
                className="styles__pointerEventsDisabled--3r2MB ignore-jqueryui-selectable vg-mouse-interactive"
                d="M 229.50820697527 285.50222405719 l -152.343331837932 173.27041780496"
                stroke="transparent"
                strokeWidth={8}
                strokeLinecap="round"
                fill="transparent"
                data-vg-test-label="smart-edge-13"
                style={{ pointerEvents: "auto" }}
              />
              <path
                data-id="edge_Yc4-N61owh"
                d="M 229.50820697527 285.50222405719 l -21.035240201640022 184.75926652496997"
                stroke="rgb(104, 42, 141)"
                strokeWidth={3}
                strokeLinecap="round"
                fill="none"
                strokeDasharray="none"
                className="styles__pointerEventsDisabled--3r2MB"
              />
              <path
                className="styles__pointerEventsDisabled--3r2MB ignore-jqueryui-selectable vg-mouse-interactive"
                d="M 229.50820697527 285.50222405719 l -21.035240201640022 184.75926652496997"
                stroke="transparent"
                strokeWidth={8}
                strokeLinecap="round"
                fill="transparent"
                data-vg-test-label="smart-edge-14"
                style={{ pointerEvents: "auto" }}
              />
              <path
                data-id="edge_16SicAzC0O"
                d="M 756.50394612863 284.50270935578 l -63.850236339769936 184.88768007727003"
                stroke="rgb(207, 10, 43)"
                strokeWidth={3}
                strokeLinecap="round"
                fill="none"
                strokeDasharray="none"
                className="styles__pointerEventsDisabled--3r2MB"
              />
              <path
                className="styles__pointerEventsDisabled--3r2MB ignore-jqueryui-selectable vg-mouse-interactive"
                d="M 756.50394612863 284.50270935578 l -63.850236339769936 184.88768007727003"
                stroke="transparent"
                strokeWidth={8}
                strokeLinecap="round"
                fill="transparent"
                data-vg-test-label="smart-edge-15"
                style={{ pointerEvents: "auto" }}
              />
              <path
                data-id="edge_nCjQN-fVDp"
                d="M 527.50677475476 468.5005374929 l 243.9473755913 146.43175058445001"
                stroke="rgb(245, 130, 31)"
                strokeWidth={3}
                strokeLinecap="round"
                fill="none"
                strokeDasharray="none"
                className="styles__pointerEventsDisabled--3r2MB"
              />
              <path
                className="styles__pointerEventsDisabled--3r2MB ignore-jqueryui-selectable vg-mouse-interactive"
                d="M 527.50677475476 468.5005374929 l 243.9473755913 146.43175058445001"
                stroke="transparent"
                strokeWidth={8}
                strokeLinecap="round"
                fill="transparent"
                data-vg-test-label="smart-edge-16"
                style={{ pointerEvents: "auto" }}
              />
              <path
                data-id="edge_1c5PwtbhdM"
                d="M 229.50820697527 285.50222405719 l 104.53055239419001 183.69998974920998"
                stroke="rgb(104, 42, 141)"
                strokeWidth={3}
                strokeLinecap="round"
                fill="none"
                strokeDasharray="none"
                className="styles__pointerEventsDisabled--3r2MB"
              />
              <path
                className="styles__pointerEventsDisabled--3r2MB ignore-jqueryui-selectable vg-mouse-interactive"
                d="M 229.50820697527 285.50222405719 l 104.53055239419001 183.69998974920998"
                stroke="transparent"
                strokeWidth={8}
                strokeLinecap="round"
                fill="transparent"
                data-vg-test-label="smart-edge-17"
                style={{ pointerEvents: "auto" }}
              />
              <path
                data-id="edge_04YY86-mQS"
                d="M 229.50820697527 285.50222405719 l 169.85848374079 86.88639857137997"
                stroke="rgb(104, 42, 141)"
                strokeWidth={3}
                strokeLinecap="round"
                fill="none"
                strokeDasharray="none"
                className="styles__pointerEventsDisabled--3r2MB"
              />
              <path
                className="styles__pointerEventsDisabled--3r2MB ignore-jqueryui-selectable vg-mouse-interactive"
                d="M 229.50820697527 285.50222405719 l 169.85848374079 86.88639857137997"
                stroke="transparent"
                strokeWidth={8}
                strokeLinecap="round"
                fill="transparent"
                data-vg-test-label="smart-edge-18"
                style={{ pointerEvents: "auto" }}
              />
              <path
                data-id="edge_i0lsMY13I6"
                d="M 756.50394612863 284.50270935578 l 56.15134122344 185.88919021612003"
                stroke="rgb(207, 10, 43)"
                strokeWidth={3}
                strokeLinecap="round"
                fill="none"
                strokeDasharray="none"
                className="styles__pointerEventsDisabled--3r2MB"
              />
              <path
                className="styles__pointerEventsDisabled--3r2MB ignore-jqueryui-selectable vg-mouse-interactive"
                d="M 756.50394612863 284.50270935578 l 56.15134122344 185.88919021612003"
                stroke="transparent"
                strokeWidth={8}
                strokeLinecap="round"
                fill="transparent"
                data-vg-test-label="smart-edge-19"
                style={{ pointerEvents: "auto" }}
              />
              <path
                data-id="edge_Bb5Cx-VLGy"
                d="M 756.50394612863 284.50270935578 l 186.76262434495004 168.59733893304002"
                stroke="rgb(207, 10, 43)"
                strokeWidth={3}
                strokeLinecap="round"
                fill="none"
                strokeDasharray="none"
                className="styles__pointerEventsDisabled--3r2MB"
              />
              <path
                className="styles__pointerEventsDisabled--3r2MB ignore-jqueryui-selectable vg-mouse-interactive"
                d="M 756.50394612863 284.50270935578 l 186.76262434495004 168.59733893304002"
                stroke="transparent"
                strokeWidth={8}
                strokeLinecap="round"
                fill="transparent"
                data-vg-test-label="smart-edge-20"
                style={{ pointerEvents: "auto" }}
              />
              <path
                data-id="edge_VY44bimAhn"
                d="M 756.50394612863 284.50270935578 l 202.14809475328002 66.88763933769002"
                stroke="rgb(207, 10, 43)"
                strokeWidth={3}
                strokeLinecap="round"
                fill="none"
                strokeDasharray="none"
                className="styles__pointerEventsDisabled--3r2MB"
              />
              <path
                className="styles__pointerEventsDisabled--3r2MB ignore-jqueryui-selectable vg-mouse-interactive"
                d="M 756.50394612863 284.50270935578 l 202.14809475328002 66.88763933769002"
                stroke="transparent"
                strokeWidth={8}
                strokeLinecap="round"
                fill="transparent"
                data-vg-test-label="smart-edge-21"
                style={{ pointerEvents: "auto" }}
              />
            </svg>
            <div
              className="styles__wrappedComponent--26Cp_ ignore-jqueryui-selectable vg-canvas-event-wrapper-component"
              data-key="3ee22676-0d09-46ca-acc8-59af1ae3a431/node_YXGY6HtUYu"
              style={{ pointerEvents: "auto" }}
            >
              <div
                data-widgettype="Diagram"
                data-id="node_YXGY6HtUYu"
                data-vg-test-label="smart-node-0"
                style={{
                  left: "442.51px",
                  top: "40.2019px",
                  width: 171,
                  height: 171,
                  background: "none",
                  position: "relative",
                  borderRadius: 0,
                  transform: "none",
                  transformOrigin: "center center"
                }}
              >
                <svg
                  className="styles__decorator--2cpkw"
                  style={{
                    width: 179,
                    height: 179,
                    transform: "translate(-4px, -4px)"
                  }}
                >
                  <circle
                    cx="89.5"
                    cy="89.5"
                    r="87.5"
                    fill="rgb(29, 40, 56)"
                    stroke="rgb(255, 255, 255)"
                    strokeWidth={4}
                    strokeDasharray=""
                  />
                </svg>
                <div
                  style={{
                    top: "25.0855px",
                    left: "25.0855px",
                    width: "120.829px",
                    height: "120.829px",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center"
                  }}
                >
                  <div
                    className="react-grid-layout styles__root--37lJs"
                    style={{ height: "96.8291px" }}
                  >
                    <div
                      className="react-grid-item styles__gridCell--18AbD"
                      style={{
                        padding: "0px 0px 1px",
                        top: 2,
                        left: 2,
                        width: 117,
                        height: 40,
                        position: "absolute"
                      }}
                    >
                      <div
                        data-id="i1"
                        className="styles__gridCellWrapper--1AQTk"
                      >
                        <div
                          className="styles__gridCell--2JKCu"
                          style={{
                            background: "rgba(242, 242, 242, 0)",
                            boxSizing: "border-box",
                            padding: 2,
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            zIndex: 0,
                            borderRadius: 0
                          }}
                        >
                          <div
                            className="styles__gridCellContent--1P2Ff"
                            style={{ width: 113, height: 35 }}
                          >
                            <div
                              data-id={0}
                              data-cellid="i1"
                              data-vg-test-label="icon-element-0"
                            >
                              <div
                                className="styles__shape--29_P3"
                                style={{ width: 113, height: 35 }}
                              >
                                <svg
                                  width="100%"
                                  height="100%"
                                  fill="rgb(255, 255, 255)"
                                  xmlns="http://www.w3.org/2000/svg"
                                  pointerEvents="bounding-box"
                                  preserveAspectRatio="xMidYMin"
                                  style={{
                                    position: "unset",
                                    pointerEvents: "none"
                                  }}
                                  viewBox="0 0 50 50"
                                >
                                  <g>
                                    <path
                                      xmlns="http://www.w3.org/2000/svg"
                                      style={{
                                        textIndent: 0,
                                        textAlign: "start",
                                        lineHeight: "normal",
                                        textTransform: "none",
                                        blockProgression: "tb",
                                        InkscapeFontSpecification:
                                          "Bitstream Vera Sans"
                                      }}
                                      d="M 25 0 C 11.204726 0 0 11.204726 0 25 C 0 38.795274 11.204726 50 25 50 C 38.795274 50 50 38.795274 50 25 C 50 11.204726 38.795274 0 25 0 z M 25 2 C 37.714394 2 48 12.285606 48 25 C 48 37.714394 37.714394 48 25 48 C 12.285606 48 2 37.714394 2 25 C 2 12.285606 12.285606 2 25 2 z"
                                      color="#000"
                                      overflow="visible"
                                      enableBackground="accumulate"
                                      fontFamily="Bitstream Vera Sans"
                                    />
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div
                            className="styles__cellBordersContainer--1CNfQ"
                            style={{
                              transform: "translateX(0px)",
                              borderRadius: 0
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className="react-grid-item styles__gridCell--18AbD"
                      style={{
                        padding: "1px 0px 0px",
                        top: 42,
                        left: 2,
                        width: 117,
                        height: 53,
                        position: "absolute"
                      }}
                    >
                      <div
                        data-id="i2"
                        className="styles__gridCellWrapper--1AQTk"
                      >
                        <div
                          className="styles__gridCell--2JKCu"
                          style={{
                            background: "rgba(242, 242, 242, 0)",
                            boxSizing: "border-box",
                            padding: 2,
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            zIndex: 0,
                            borderRadius: 0
                          }}
                        >
                          <div
                            className="styles__gridCellContent--1P2Ff"
                            style={{ width: "100%", height: "auto" }}
                          >
                            <div
                              data-id={0}
                              data-cellid="i2"
                              data-vg-test-label="text-element-0"
                              style={{ width: "100%" }}
                            >
                              <div>
                                <div
                                  id="draftEditor-3ee22676-0d09-46ca-acc8-59af1ae3a431"
                                  className="styles__cleanCssRoot--SYmyP"
                                  style={{ textAlign: "center" }}
                                >
                                  <div className="DraftEditor-root">
                                    <div
                                      className="DraftEditor-editorContainer"
                                      style={{ position: "initial" }}
                                    >
                                      <div
                                        aria-describedby="placeholder-56qa"
                                        className="public-DraftEditor-content"
                                        contentEditable="false"
                                        spellCheck="true"
                                        style={{
                                          outline: "none",
                                          userSelect: "text",
                                          whiteSpace: "pre-wrap",
                                          overflowWrap: "break-word"
                                        }}
                                      >
                                        <div data-contents="true">
                                          <div
                                            className="draftjs-textalign-center"
                                            data-block="true"
                                            data-editor="56qa"
                                            data-offset-key="default-0-0"
                                            style={{
                                              fontFamily:
                                                '"Barlow Condensed"',
                                              fontSize: 20,
                                              color: "rgb(255, 255, 255)",
                                              lineHeight: "1.2"
                                            }}
                                          >
                                            <div
                                              data-offset-key="default-0-0"
                                              className="public-DraftStyleDefault-block public-DraftStyleDefault-ltr"
                                            >
                                              <span
                                                data-offset-key="default-0-0"
                                                style={{
                                                  fontFamily:
                                                    '"Barlow Condensed"',
                                                  fontSize: 20,
                                                  color: "rgb(255, 255, 255)",
                                                  lineHeight: "1.2",
                                                  fontWeight: "normal",
                                                  fontStyle: "normal"
                                                }}
                                              >
                                                <span data-text="true">
                                                  DIYA
                                                </span>
                                              </span>
                                            </div>
                                          </div>
                                          <div
                                            className="draftjs-textalign-center"
                                            data-block="true"
                                            data-editor="56qa"
                                            data-offset-key="1o7dm-0-0"
                                            style={{
                                              fontFamily:
                                                '"Barlow Condensed"',
                                              fontSize: 20,
                                              color: "rgb(255, 255, 255)",
                                              lineHeight: "1.2"
                                            }}
                                          >
                                            <div
                                              data-offset-key="1o7dm-0-0"
                                              className="public-DraftStyleDefault-block public-DraftStyleDefault-ltr"
                                            >
                                              <span
                                                data-offset-key="1o7dm-0-0"
                                                style={{
                                                  fontFamily:
                                                    '"Barlow Condensed"',
                                                  fontSize: 20,
                                                  color: "rgb(255, 255, 255)",
                                                  lineHeight: "1.2",
                                                  fontWeight: "normal",
                                                  fontStyle: "normal"
                                                }}
                                              >
                                                <span data-text="true">
                                                  Holdings
                                                </span>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="styles__cellBordersContainer--1CNfQ"
                            style={{
                              transform: "translateX(0px)",
                              borderRadius: 0
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="styles__wrappedComponent--26Cp_ ignore-jqueryui-selectable vg-canvas-event-wrapper-component"
              data-key="3ee22676-0d09-46ca-acc8-59af1ae3a431/node_OW57ICtimh"
              style={{ pointerEvents: "auto" }}
            >
              <div
                data-widgettype="Diagram"
                data-id="node_OW57ICtimh"
                data-vg-test-label="smart-node-1"
                style={{
                  left: "646.004px",
                  top: "65.0084px",
                  width: 120,
                  height: 120,
                  background: "none",
                  position: "relative",
                  borderRadius: 0,
                  transform: "none",
                  transformOrigin: "center center"
                }}
              >
                <svg
                  className="styles__decorator--2cpkw"
                  style={{
                    width: 126,
                    height: 126,
                    transform: "translate(-3px, -3px)"
                  }}
                >
                  <circle
                    cx={63}
                    cy={63}
                    r="61.5"
                    fill="rgb(207, 180, 128)"
                    stroke="rgb(255, 255, 255)"
                    strokeWidth={3}
                    strokeDasharray=""
                  />
                </svg>
                <div
                  style={{
                    top: "17.5736px",
                    left: "17.5736px",
                    width: "84.8528px",
                    height: "84.8528px",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center"
                  }}
                >
                  <div
                    className="react-grid-layout styles__root--37lJs"
                    style={{ height: "66.8291px" }}
                  >
                    <div
                      className="react-grid-item styles__gridCell--18AbD"
                      style={{
                        padding: "0px 0px 1px",
                        top: 2,
                        left: 2,
                        width: 81,
                        height: 40,
                        position: "absolute"
                      }}
                    >
                      <div
                        data-id="i1"
                        className="styles__gridCellWrapper--1AQTk"
                      >
                        <div
                          className="styles__gridCell--2JKCu"
                          style={{
                            background: "rgba(242, 242, 242, 0)",
                            boxSizing: "border-box",
                            padding: 2,
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            zIndex: 0,
                            borderRadius: 0
                          }}
                        >
                          <div
                            className="styles__gridCellContent--1P2Ff"
                            style={{ width: 77, height: 35 }}
                          >
                            <div
                              data-id={0}
                              data-cellid="i1"
                              data-vg-test-label="icon-element-0"
                            >
                              <div
                                className="styles__shape--29_P3"
                                style={{ width: 77, height: 35 }}
                              >
                                <svg
                                  width="100%"
                                  height="100%"
                                  fill="rgb(255, 255, 255)"
                                  xmlns="http://www.w3.org/2000/svg"
                                  pointerEvents="bounding-box"
                                  preserveAspectRatio="xMidYMin"
                                  style={{
                                    position: "unset",
                                    pointerEvents: "none"
                                  }}
                                  viewBox="2 2 22 22"
                                >
                                  <g>
                                    <path
                                      xmlns="http://www.w3.org/2000/svg"
                                      style={{
                                        textIndent: 0,
                                        textAlign: "start",
                                        lineHeight: "normal",
                                        textTransform: "none",
                                        blockProgression: "tb",
                                        InkscapeFontSpecification:
                                          "Bitstream Vera Sans"
                                      }}
                                      d="M 4.8125 2 C 3.2125 2 2 3.4151515 2 5 C 2 6.5848485 3.2125 8 4.8125 8 L 5 8 L 5 17 C 5 19.9 6.8333333 22 9 22 L 14 22 L 14 20 L 9 20 C 8.1666667 20 7 19.1 7 17 L 7 8 L 14 8 L 14 7 L 14 6 C 13.533333 6 13 5.6444444 13 5 C 13 4.3555556 13.533333 4 14 4 C 14.833333 4 16 4.9 16 7 L 16 17 L 18 17 L 18 7 C 18 4.1 16.166667 2 14 2 L 4.8125 2 z M 4.8125 4 L 11.21875 4 C 11.106841 4.3114553 11 4.6389204 11 5 C 11 5.3610796 11.106841 5.6885447 11.21875 6 L 4.8125 6 C 4.4125 6 4 5.6151515 4 5 C 4 4.3848485 4.4125 4 4.8125 4 z M 9 10 L 9 12 L 14 12 L 14 10 L 9 10 z M 9 14 L 9 16 L 14 16 L 14 14 L 9 14 z M 19 16 L 19 19 L 16 19 L 16 21 L 19 21 L 19 24 L 21 24 L 21 21 L 24 21 L 24 19 L 21 19 L 21 16 L 19 16 z"
                                      color="#000"
                                      overflow="visible"
                                      enableBackground="accumulate"
                                      fontFamily="Bitstream Vera Sans"
                                    />
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div
                            className="styles__cellBordersContainer--1CNfQ"
                            style={{
                              transform: "translateX(0px)",
                              borderRadius: 0
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className="react-grid-item styles__gridCell--18AbD"
                      style={{
                        padding: "1px 0px 0px",
                        top: 42,
                        left: 2,
                        width: 81,
                        height: 23,
                        position: "absolute"
                      }}
                    >
                      <div
                        data-id="i2"
                        className="styles__gridCellWrapper--1AQTk"
                      >
                        <div
                          className="styles__gridCell--2JKCu"
                          style={{
                            background: "rgba(242, 242, 242, 0)",
                            boxSizing: "border-box",
                            padding: 2,
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            zIndex: 0,
                            borderRadius: 0
                          }}
                        >
                          <div
                            className="styles__gridCellContent--1P2Ff"
                            style={{ width: "100%", height: "auto" }}
                          >
                            <div
                              data-id={0}
                              data-cellid="i2"
                              data-vg-test-label="text-element-0"
                              style={{ width: "100%" }}
                            >
                              <div>
                                <div
                                  id="draftEditor-3ee22676-0d09-46ca-acc8-59af1ae3a431"
                                  className="styles__cleanCssRoot--SYmyP"
                                  style={{ textAlign: "center" }}
                                >
                                  <div className="DraftEditor-root">
                                    <div
                                      className="DraftEditor-editorContainer"
                                      style={{ position: "initial" }}
                                    >
                                      <div
                                        aria-describedby="placeholder-bup2"
                                        className="public-DraftEditor-content"
                                        contentEditable="false"
                                        spellCheck="true"
                                        style={{
                                          outline: "none",
                                          userSelect: "text",
                                          whiteSpace: "pre-wrap",
                                          overflowWrap: "break-word"
                                        }}
                                      >
                                        <div data-contents="true">
                                          <div
                                            className="draftjs-textalign-center"
                                            data-block="true"
                                            data-editor="bup2"
                                            data-offset-key="default-0-0"
                                            style={{
                                              fontFamily:
                                                '"Barlow Condensed"',
                                              fontSize: 15,
                                              color: "rgb(255, 255, 255)",
                                              lineHeight: "1.2"
                                            }}
                                          >
                                            <div
                                              data-offset-key="default-0-0"
                                              className="public-DraftStyleDefault-block public-DraftStyleDefault-ltr"
                                            >
                                              <span
                                                data-offset-key="default-0-0"
                                                style={{
                                                  fontFamily:
                                                    '"Barlow Condensed"',
                                                  fontSize: 15,
                                                  color: "rgb(255, 255, 255)",
                                                  lineHeight: "1.2",
                                                  fontWeight: "normal",
                                                  fontStyle: "normal"
                                                }}
                                              >
                                                <span data-text="true">
                                                  CHASE
                                                </span>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="styles__cellBordersContainer--1CNfQ"
                            style={{
                              transform: "translateX(0px)",
                              borderRadius: 0
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="styles__wrappedComponent--26Cp_ ignore-jqueryui-selectable vg-canvas-event-wrapper-component"
              data-key="3ee22676-0d09-46ca-acc8-59af1ae3a431/node_ZjFE5qNz7p"
              style={{ pointerEvents: "auto" }}
            >
              <div
                data-widgettype="Diagram"
                data-id="node_ZjFE5qNz7p"
                data-vg-test-label="smart-node-2"
                style={{
                  left: "810.516px",
                  top: "67.709px",
                  width: "114.159px",
                  height: "114.159px",
                  background: "none",
                  position: "relative",
                  borderRadius: 0,
                  transform: "none",
                  transformOrigin: "center center"
                }}
              >
                <svg
                  className="styles__decorator--2cpkw"
                  style={{
                    width: "122.159px",
                    height: "122.159px",
                    transform: "translate(-4px, -4px)"
                  }}
                >
                  <circle
                    cx="61.0793699901"
                    cy="61.0793699901"
                    r="59.0793699901"
                    fill="rgb(255, 255, 255)"
                    stroke="rgb(255, 255, 255)"
                    strokeWidth={4}
                    strokeDasharray=""
                  />
                </svg>
                <div
                  style={{
                    top: "16.7968px",
                    left: "16.7968px",
                    width: "80.5651px",
                    height: "80.5651px",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center"
                  }}
                >
                  <div
                    className="react-grid-layout styles__root--37lJs"
                    style={{ height: "66.8291px" }}
                  >
                    <div
                      className="react-grid-item styles__gridCell--18AbD"
                      style={{
                        padding: "0px 0px 1px",
                        top: 2,
                        left: 2,
                        width: 77,
                        height: 40,
                        position: "absolute"
                      }}
                    >
                      <div
                        data-id="i1"
                        className="styles__gridCellWrapper--1AQTk"
                      >
                        <div
                          className="styles__gridCell--2JKCu"
                          style={{
                            background: "rgba(242, 242, 242, 0)",
                            boxSizing: "border-box",
                            padding: 2,
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            zIndex: 0,
                            borderRadius: 0
                          }}
                        >
                          <div
                            className="styles__gridCellContent--1P2Ff"
                            style={{ width: 73, height: 35 }}
                          >
                            <div
                              data-id={0}
                              data-cellid="i1"
                              data-vg-test-label="icon-element-0"
                            >
                              <div
                                className="styles__shape--29_P3"
                                style={{ width: 73, height: 35 }}
                              >
                                <svg
                                  width="100%"
                                  height="100%"
                                  fill="rgb(207, 180, 128)"
                                  xmlns="http://www.w3.org/2000/svg"
                                  pointerEvents="bounding-box"
                                  preserveAspectRatio="xMidYMin"
                                  style={{
                                    position: "unset",
                                    pointerEvents: "none"
                                  }}
                                  viewBox="2 0 22 26"
                                >
                                  <g>
                                    <path
                                      xmlns="http://www.w3.org/2000/svg"
                                      style={{
                                        textIndent: 0,
                                        textAlign: "start",
                                        lineHeight: "normal",
                                        textTransform: "none",
                                        blockProgression: "tb",
                                        InkscapeFontSpecification:
                                          "Bitstream Vera Sans"
                                      }}
                                      d="M 10.8125 0 A 1.0001 1.0001 0 0 0 10 1 L 10 2 A 1.0001 1.0001 0 0 0 11 3 L 11 4.1875 C 5.8914889 5.1317164 2 9.6253217 2 15 C 2 21.057666 6.9464777 26 13 26 C 19.057749 26 24 21.056713 24 15 C 24 11.867727 22.677818 9.0385535 20.5625 7.03125 L 21.625 5.71875 A 1.0002485 1.0002485 0 0 0 21.46875 4.3125 L 20.25 3.375 A 1.0002485 1.0002485 0 0 0 20.1875 3.3125 A 1.0002485 1.0002485 0 0 0 18.84375 3.53125 L 17.65625 5.0625 C 16.821493 4.6700812 15.932002 4.3597183 15 4.1875 L 15 3 A 1.0001 1.0001 0 0 0 16 2 L 16 1 A 1.0001 1.0001 0 0 0 15 0 L 11 0 A 1.0001 1.0001 0 0 0 10.90625 0 A 1.0001 1.0001 0 0 0 10.8125 0 z M 13 7 C 17.43587 7 21 10.567022 21 15 C 21 19.435287 17.436251 23 13 23 C 8.5695223 23 5 19.434334 5 15 C 5 10.567976 8.5699039 7 13 7 z M 6.875 10.28125 C 6.69125 10.314 6.51925 10.42325 6.40625 10.59375 C 6.17725 10.93475 6.307 11.329 6.625 11.625 C 6.8622732 11.844873 9.6438809 14.107453 11.03125 15.25 C 11.155065 16.235715 11.98071 17 13 17 C 14.104569 17 15 16.104569 15 15 C 15 13.895431 14.104569 13 13 13 C 12.817056 13 12.637102 13.016492 12.46875 13.0625 C 10.836074 12.200371 7.5984027 10.4938 7.4375 10.40625 C 7.2585 10.30775 7.05875 10.2485 6.875 10.28125 z"
                                      color="#000"
                                      overflow="visible"
                                      enableBackground="accumulate"
                                      fontFamily="Bitstream Vera Sans"
                                    />
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div
                            className="styles__cellBordersContainer--1CNfQ"
                            style={{
                              transform: "translateX(0px)",
                              borderRadius: 0
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className="react-grid-item styles__gridCell--18AbD"
                      style={{
                        padding: "1px 0px 0px",
                        top: 42,
                        left: 2,
                        width: 77,
                        height: 23,
                        position: "absolute"
                      }}
                    >
                      <div
                        data-id="i2"
                        className="styles__gridCellWrapper--1AQTk"
                      >
                        <div
                          className="styles__gridCell--2JKCu"
                          style={{
                            background: "rgba(242, 242, 242, 0)",
                            boxSizing: "border-box",
                            padding: 2,
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            zIndex: 0,
                            borderRadius: 0
                          }}
                        >
                          <div
                            className="styles__gridCellContent--1P2Ff"
                            style={{ width: "100%", height: "auto" }}
                          >
                            <div
                              data-id={0}
                              data-cellid="i2"
                              data-vg-test-label="text-element-0"
                              style={{ width: "100%" }}
                            >
                              <div>
                                <div
                                  id="draftEditor-3ee22676-0d09-46ca-acc8-59af1ae3a431"
                                  className="styles__cleanCssRoot--SYmyP"
                                  style={{ textAlign: "center" }}
                                >
                                  <div className="DraftEditor-root">
                                    <div
                                      className="DraftEditor-editorContainer"
                                      style={{ position: "initial" }}
                                    >
                                      <div
                                        aria-describedby="placeholder-73l0t"
                                        className="public-DraftEditor-content"
                                        contentEditable="false"
                                        spellCheck="true"
                                        style={{
                                          outline: "none",
                                          userSelect: "text",
                                          whiteSpace: "pre-wrap",
                                          overflowWrap: "break-word"
                                        }}
                                      >
                                        <div data-contents="true">
                                          <div
                                            className="draftjs-textalign-center"
                                            data-block="true"
                                            data-editor="73l0t"
                                            data-offset-key="default-0-0"
                                            style={{
                                              fontFamily:
                                                '"Barlow Condensed"',
                                              fontSize: 15,
                                              color: "rgb(0, 0, 0)",
                                              lineHeight: "1.2"
                                            }}
                                          >
                                            <div
                                              data-offset-key="default-0-0"
                                              className="public-DraftStyleDefault-block public-DraftStyleDefault-ltr"
                                            >
                                              <span
                                                data-offset-key="default-0-0"
                                                style={{
                                                  fontFamily:
                                                    '"Barlow Condensed"',
                                                  fontSize: 15,
                                                  color: "rgb(0, 0, 0)",
                                                  lineHeight: "1.2",
                                                  fontWeight: "normal",
                                                  fontStyle: "normal"
                                                }}
                                              >
                                                <span data-text="true">
                                                  Old National
                                                </span>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="styles__cellBordersContainer--1CNfQ"
                            style={{
                              transform: "translateX(0px)",
                              borderRadius: 0
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="styles__wrappedComponent--26Cp_ ignore-jqueryui-selectable vg-canvas-event-wrapper-component"
              data-key="3ee22676-0d09-46ca-acc8-59af1ae3a431/node_aq9VmanGxA"
              style={{ pointerEvents: "auto" }}
            >
              <div
                data-widgettype="Diagram"
                data-id="node_aq9VmanGxA"
                data-vg-test-label="smart-node-3"
                style={{
                  left: "701.004px",
                  top: "229.003px",
                  width: 111,
                  height: 111,
                  background: "none",
                  position: "relative",
                  borderRadius: 0,
                  transform: "none",
                  transformOrigin: "center center"
                }}
              >
                <svg
                  className="styles__decorator--2cpkw"
                  style={{
                    width: 117,
                    height: 117,
                    transform: "translate(-3px, -3px)"
                  }}
                >
                  <circle
                    cx="58.5"
                    cy="58.5"
                    r={57}
                    fill="rgb(81, 122, 128)"
                    stroke="rgb(207, 10, 43)"
                    strokeWidth={3}
                    strokeDasharray=""
                  />
                </svg>
                <div
                  style={{
                    top: "11.3058px",
                    left: "11.3058px",
                    width: "88.3883px",
                    height: "88.3883px",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center"
                  }}
                >
                  <div
                    className="react-grid-layout styles__root--37lJs"
                    style={{ height: "66.8291px" }}
                  >
                    <div
                      className="react-grid-item styles__gridCell--18AbD"
                      style={{
                        padding: "0px 0px 1px",
                        top: 2,
                        left: 2,
                        width: 84,
                        height: 40,
                        position: "absolute"
                      }}
                    >
                      <div
                        data-id="i1"
                        className="styles__gridCellWrapper--1AQTk"
                      >
                        <div
                          className="styles__gridCell--2JKCu"
                          style={{
                            background: "rgba(242, 242, 242, 0)",
                            boxSizing: "border-box",
                            padding: 2,
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            zIndex: 0,
                            borderRadius: 0
                          }}
                        >
                          <div
                            className="styles__gridCellContent--1P2Ff"
                            style={{ width: 80, height: 35 }}
                          >
                            <div
                              data-id={0}
                              data-cellid="i1"
                              data-vg-test-label="icon-element-0"
                            >
                              <div
                                className="styles__shape--29_P3"
                                style={{ width: 80, height: 35 }}
                              >
                                <svg
                                  width="100%"
                                  height="100%"
                                  fill="rgb(255, 255, 255)"
                                  xmlns="http://www.w3.org/2000/svg"
                                  pointerEvents="bounding-box"
                                  preserveAspectRatio="xMidYMin"
                                  style={{
                                    position: "unset",
                                    pointerEvents: "none"
                                  }}
                                  viewBox="0 0 26 26"
                                >
                                  <g>
                                    <path
                                      xmlns="http://www.w3.org/2000/svg"
                                      d="M 7 0 C 6.449 0 6 0.449 6 1 L 6 4 C 6 4.551 6.449 5 7 5 C 7.551 5 8 4.551 8 4 L 8 1 C 8 0.449 7.551 0 7 0 z M 19 0 C 18.449 0 18 0.449 18 1 L 18 4 C 18 4.551 18.449 5 19 5 C 19.551 5 20 4.551 20 4 L 20 1 C 20 0.449 19.551 0 19 0 z M 3 2 C 1.344 2 0 3.344 0 5 L 0 23 C 0 24.656 1.344 26 3 26 L 23 26 C 24.656 26 26 24.656 26 23 L 26 5 C 26 3.344 24.656 2 23 2 L 21 2 L 21 4 C 21 5.103 20.103 6 19 6 C 17.896 6 17 5.103 17 4 L 17 2 L 9 2 L 9 4 C 9 5.103 8.103 6 7 6 C 5.897 6 5 5.103 5 4 L 5 2 L 3 2 z M 2 9 L 24 9 L 24 23 C 24 23.551 23.551 24 23 24 L 3 24 C 2.449 24 2 23.551 2 23 L 2 9 z M 13 11 L 9 15 L 17 15 L 13 11 z M 9 18 L 13 22 L 17 18 L 9 18 z"
                                    />
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div
                            className="styles__cellBordersContainer--1CNfQ"
                            style={{
                              transform: "translateX(0px)",
                              borderRadius: 0
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className="react-grid-item styles__gridCell--18AbD"
                      style={{
                        padding: "1px 0px 0px",
                        top: 42,
                        left: 2,
                        width: 84,
                        height: 23,
                        position: "absolute"
                      }}
                    >
                      <div
                        data-id="i2"
                        className="styles__gridCellWrapper--1AQTk"
                      >
                        <div
                          className="styles__gridCell--2JKCu"
                          style={{
                            background: "rgba(242, 242, 242, 0)",
                            boxSizing: "border-box",
                            padding: 2,
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            zIndex: 0,
                            borderRadius: 0
                          }}
                        >
                          <div
                            className="styles__gridCellContent--1P2Ff"
                            style={{ width: "100%", height: "auto" }}
                          >
                            <div
                              data-id={0}
                              data-cellid="i2"
                              data-vg-test-label="text-element-0"
                              style={{ width: "100%" }}
                            >
                              <div>
                                <div
                                  id="draftEditor-3ee22676-0d09-46ca-acc8-59af1ae3a431"
                                  className="styles__cleanCssRoot--SYmyP"
                                  style={{ textAlign: "center" }}
                                >
                                  <div className="DraftEditor-root">
                                    <div
                                      className="DraftEditor-editorContainer"
                                      style={{ position: "initial" }}
                                    >
                                      <div
                                        aria-describedby="placeholder-acb2k"
                                        className="public-DraftEditor-content"
                                        contentEditable="false"
                                        spellCheck="true"
                                        style={{
                                          outline: "none",
                                          userSelect: "text",
                                          whiteSpace: "pre-wrap",
                                          overflowWrap: "break-word"
                                        }}
                                      >
                                        <div data-contents="true">
                                          <div
                                            className="draftjs-textalign-center"
                                            data-block="true"
                                            data-editor="acb2k"
                                            data-offset-key="default-0-0"
                                            style={{
                                              fontFamily:
                                                '"Barlow Condensed"',
                                              fontSize: 15,
                                              color: "rgb(255, 255, 255)",
                                              lineHeight: "1.2"
                                            }}
                                          >
                                            <div
                                              data-offset-key="default-0-0"
                                              className="public-DraftStyleDefault-block public-DraftStyleDefault-ltr"
                                            >
                                              <span
                                                data-offset-key="default-0-0"
                                                style={{
                                                  fontFamily:
                                                    '"Barlow Condensed"',
                                                  fontSize: 15,
                                                  color: "rgb(255, 255, 255)",
                                                  lineHeight: "1.2",
                                                  fontWeight: "normal",
                                                  fontStyle: "normal"
                                                }}
                                              >
                                                <span data-text="true">
                                                  Jimmy Johns
                                                </span>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="styles__cellBordersContainer--1CNfQ"
                            style={{
                              transform: "translateX(0px)",
                              borderRadius: 0
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="styles__wrappedComponent--26Cp_ ignore-jqueryui-selectable vg-canvas-event-wrapper-component"
              data-key="3ee22676-0d09-46ca-acc8-59af1ae3a431/node_HiGus5Sfl1"
              style={{ pointerEvents: "auto" }}
            >
              <div
                data-widgettype="Diagram"
                data-id="node_HiGus5Sfl1"
                data-vg-test-label="smart-node-4"
                style={{
                  left: "293.012px",
                  top: "65.0029px",
                  width: 120,
                  height: 120,
                  background: "none",
                  position: "relative",
                  borderRadius: 0,
                  transform: "none",
                  transformOrigin: "center center"
                }}
              >
                <svg
                  className="styles__decorator--2cpkw"
                  style={{
                    width: 126,
                    height: 126,
                    transform: "translate(-3px, -3px)"
                  }}
                >
                  <circle
                    cx={63}
                    cy={63}
                    r="61.5"
                    fill="rgb(214, 102, 51)"
                    stroke="rgb(255, 255, 255)"
                    strokeWidth={3}
                    strokeDasharray=""
                  />
                </svg>
                <div
                  style={{
                    top: "17.5855px",
                    left: "17.5855px",
                    width: "84.8291px",
                    height: "84.8291px",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center"
                  }}
                >
                  <div
                    className="react-grid-layout styles__root--37lJs"
                    style={{ height: "66.8291px" }}
                  >
                    <div
                      className="react-grid-item styles__gridCell--18AbD"
                      style={{
                        padding: "0px 0px 1px",
                        top: 2,
                        left: 2,
                        width: 81,
                        height: 40,
                        position: "absolute"
                      }}
                    >
                      <div
                        data-id="i1"
                        className="styles__gridCellWrapper--1AQTk"
                      >
                        <div
                          className="styles__gridCell--2JKCu"
                          style={{
                            background: "rgba(242, 242, 242, 0)",
                            boxSizing: "border-box",
                            padding: 2,
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            zIndex: 0,
                            borderRadius: 0
                          }}
                        >
                          <div
                            className="styles__gridCellContent--1P2Ff"
                            style={{ width: 77, height: 35 }}
                          >
                            <div
                              data-id={0}
                              data-cellid="i1"
                              data-vg-test-label="icon-element-0"
                            >
                              <div
                                className="styles__shape--29_P3"
                                style={{ width: 77, height: 35 }}
                              >
                                <svg
                                  width="100%"
                                  height="100%"
                                  fill="rgb(255, 255, 255)"
                                  xmlns="http://www.w3.org/2000/svg"
                                  pointerEvents="bounding-box"
                                  preserveAspectRatio="xMidYMin"
                                  style={{
                                    position: "unset",
                                    pointerEvents: "none"
                                  }}
                                  viewBox="4.2813 5.2813 23.7188 22.125"
                                >
                                  <g>
                                    <path
                                      xmlns="http://www.w3.org/2000/svg"
                                      style={{
                                        textIndent: 0,
                                        textAlign: "start",
                                        lineHeight: "normal",
                                        textTransform: "none",
                                        blockProgression: "tb",
                                        InkscapeFontSpecification:
                                          "Bitstream Vera Sans"
                                      }}
                                      d="M 10.28125 5.28125 L 7 8.5625 L 5.71875 7.28125 L 4.28125 8.71875 L 6.28125 10.71875 L 7 11.40625 L 7.71875 10.71875 L 11.71875 6.71875 L 10.28125 5.28125 z M 15 7 L 15 9 L 28 9 L 28 7 L 15 7 z M 10.28125 13.28125 L 7 16.5625 L 5.71875 15.28125 L 4.28125 16.71875 L 6.28125 18.71875 L 7 19.40625 L 7.71875 18.71875 L 11.71875 14.71875 L 10.28125 13.28125 z M 15 15 L 15 17 L 28 17 L 28 15 L 15 15 z M 10.28125 21.28125 L 7 24.5625 L 5.71875 23.28125 L 4.28125 24.71875 L 6.28125 26.71875 L 7 27.40625 L 7.71875 26.71875 L 11.71875 22.71875 L 10.28125 21.28125 z M 15 23 L 15 25 L 28 25 L 28 23 L 15 23 z"
                                    />
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div
                            className="styles__cellBordersContainer--1CNfQ"
                            style={{
                              transform: "translateX(0px)",
                              borderRadius: 0
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className="react-grid-item styles__gridCell--18AbD"
                      style={{
                        padding: "1px 0px 0px",
                        top: 42,
                        left: 2,
                        width: 81,
                        height: 23,
                        position: "absolute"
                      }}
                    >
                      <div
                        data-id="i2"
                        className="styles__gridCellWrapper--1AQTk"
                      >
                        <div
                          className="styles__gridCell--2JKCu"
                          style={{
                            background: "rgba(242, 242, 242, 0)",
                            boxSizing: "border-box",
                            padding: 2,
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            zIndex: 0,
                            borderRadius: 0
                          }}
                        >
                          <div
                            className="styles__gridCellContent--1P2Ff"
                            style={{ width: "100%", height: "auto" }}
                          >
                            <div
                              data-id={0}
                              data-cellid="i2"
                              data-vg-test-label="text-element-0"
                              style={{ width: "100%" }}
                            >
                              <div>
                                <div
                                  id="draftEditor-3ee22676-0d09-46ca-acc8-59af1ae3a431"
                                  className="styles__cleanCssRoot--SYmyP"
                                  style={{ textAlign: "center" }}
                                >
                                  <div className="DraftEditor-root">
                                    <div
                                      className="DraftEditor-editorContainer"
                                      style={{ position: "initial" }}
                                    >
                                      <div
                                        aria-describedby="placeholder-173r7"
                                        className="public-DraftEditor-content"
                                        contentEditable="false"
                                        spellCheck="true"
                                        style={{
                                          outline: "none",
                                          userSelect: "text",
                                          whiteSpace: "pre-wrap",
                                          overflowWrap: "break-word"
                                        }}
                                      >
                                        <div data-contents="true">
                                          <div
                                            className="draftjs-textalign-center"
                                            data-block="true"
                                            data-editor="173r7"
                                            data-offset-key="default-0-0"
                                            style={{
                                              fontFamily:
                                                '"Barlow Condensed"',
                                              fontSize: 15,
                                              color: "rgb(255, 255, 255)",
                                              lineHeight: "1.2"
                                            }}
                                          >
                                            <div
                                              data-offset-key="default-0-0"
                                              className="public-DraftStyleDefault-block public-DraftStyleDefault-ltr"
                                            >
                                              <span
                                                data-offset-key="default-0-0"
                                                style={{
                                                  fontFamily:
                                                    '"Barlow Condensed"',
                                                  fontSize: 15,
                                                  color: "rgb(255, 255, 255)",
                                                  lineHeight: "1.2",
                                                  fontWeight: "normal",
                                                  fontStyle: "normal"
                                                }}
                                              >
                                                <span data-text="true">
                                                  QuickBooks
                                                </span>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="styles__cellBordersContainer--1CNfQ"
                            style={{
                              transform: "translateX(0px)",
                              borderRadius: 0
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="styles__wrappedComponent--26Cp_ ignore-jqueryui-selectable vg-canvas-event-wrapper-component"
              data-key="3ee22676-0d09-46ca-acc8-59af1ae3a431/node_a08-a0yGCQ"
              style={{ pointerEvents: "auto" }}
            >
              <div
                data-widgettype="Diagram"
                data-id="node_a08-a0yGCQ"
                data-vg-test-label="smart-node-5"
                style={{
                  left: "174.008px",
                  top: "230.002px",
                  width: 111,
                  height: 111,
                  background: "none",
                  position: "relative",
                  borderRadius: 0,
                  transform: "none",
                  transformOrigin: "center center"
                }}
              >
                <svg
                  className="styles__decorator--2cpkw"
                  style={{
                    width: 117,
                    height: 117,
                    transform: "translate(-3px, -3px)"
                  }}
                >
                  <circle
                    cx="58.5"
                    cy="58.5"
                    r={57}
                    fill="rgb(81, 122, 128)"
                    stroke="rgb(104, 42, 141)"
                    strokeWidth={3}
                    strokeDasharray=""
                  />
                </svg>
                <div
                  style={{
                    top: "11.3058px",
                    left: "11.3058px",
                    width: "88.3883px",
                    height: "88.3883px",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center"
                  }}
                >
                  <div
                    className="react-grid-layout styles__root--37lJs"
                    style={{ height: "66.8291px" }}
                  >
                    <div
                      className="react-grid-item styles__gridCell--18AbD"
                      style={{
                        padding: "0px 0px 1px",
                        top: 2,
                        left: 2,
                        width: 84,
                        height: 40,
                        position: "absolute"
                      }}
                    >
                      <div
                        data-id="i1"
                        className="styles__gridCellWrapper--1AQTk"
                      >
                        <div
                          className="styles__gridCell--2JKCu"
                          style={{
                            background: "rgba(242, 242, 242, 0)",
                            boxSizing: "border-box",
                            padding: 2,
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            zIndex: 0,
                            borderRadius: 0
                          }}
                        >
                          <div
                            className="styles__gridCellContent--1P2Ff"
                            style={{ width: 80, height: 35 }}
                          >
                            <div
                              data-id={0}
                              data-cellid="i1"
                              data-vg-test-label="icon-element-0"
                            >
                              <div
                                className="styles__shape--29_P3"
                                style={{ width: 80, height: 35 }}
                              >
                                <svg
                                  width="100%"
                                  height="100%"
                                  fill="rgb(255, 255, 255)"
                                  xmlns="http://www.w3.org/2000/svg"
                                  pointerEvents="bounding-box"
                                  preserveAspectRatio="xMidYMin"
                                  style={{
                                    position: "unset",
                                    pointerEvents: "none"
                                  }}
                                  viewBox="1 0.0898 24.0586 25.8789"
                                >
                                  <g>
                                    <path
                                      xmlns="http://www.w3.org/2000/svg"
                                      style={{
                                        textIndent: 0,
                                        textAlign: "start",
                                        lineHeight: "normal",
                                        textTransform: "none",
                                        blockProgression: "tb",
                                        InkscapeFontSpecification:
                                          "Bitstream Vera Sans"
                                      }}
                                      d="M 20.84375 0.09375 C 20.63125 0.06875 20.3875 0.2 20.1875 0.5 L 18.21875 3.1875 C 16.648399 2.4393084 14.889565 2 13 2 C 6.3896552 2 1 7.3896552 1 14 L 1 14.0625 A 1.50015 1.50015 0 0 0 1 14.1875 L 1.0625 15.15625 L 1.0625 15.3125 L 1.21875 16.21875 L 1.9375 17.28125 L 3.21875 17.40625 L 4.125 16.46875 L 4.1875 15.75 L 4.0625 15 L 4 14.09375 A 1.50015 1.50015 0 0 0 4 14 L 4 13.9375 C 4.0331912 8.9767822 8.031112 5 13 5 C 14.234955 5 15.373423 5.2111266 16.40625 5.625 L 14.8125 7.8125 C 14.4125 8.4125 14.4 8.80625 15 8.90625 L 24.1875 10.1875 C 24.8875 10.2875 25.2 9.8875 25 9.1875 L 21.40625 0.59375 C 21.25625 0.29375 21.05625 0.11875 20.84375 0.09375 z M 23.21875 15.4375 L 22 15.90625 L 21.65625 16.5 L 21.5 17 L 21.28125 17.59375 L 21.25 17.59375 L 21 18.125 L 20.96875 19.40625 L 21.9375 20.25 L 23.21875 20 L 23.6875 19.46875 L 23.9375 18.96875 L 24 18.84375 L 24.34375 17.96875 L 24.375 17.84375 L 24.53125 17.375 L 24.3125 16.09375 L 23.21875 15.4375 z M 4.8125 19 L 3.625 19.5 L 3.28125 20.75 L 3.5625 21.375 L 3.6875 21.5625 L 3.78125 21.6875 L 4.46875 22.4375 L 4.5625 22.53125 L 5.125 23.03125 L 6.375 23.40625 L 7.4375 22.6875 L 7.53125 21.40625 L 7.15625 20.8125 L 6.6875 20.40625 L 6.625 20.34375 L 6.59375 20.3125 L 6.09375 19.78125 L 6.03125 19.6875 L 6 19.65625 L 5.96875 19.59375 L 4.8125 19 z M 18.9375 21.0625 L 18.28125 21.28125 L 17.6875 21.6875 L 17.59375 21.75 L 17 22.0625 L 16.96875 22.09375 L 16.875 22.125 L 16.78125 22.15625 L 15.9375 23.125 L 16.15625 24.40625 L 17.28125 25.03125 L 17.96875 24.90625 L 18.1875 24.8125 L 18.3125 24.75 L 19.125 24.3125 L 19.25 24.25 L 19.9375 23.78125 L 20.59375 22.6875 L 20.15625 21.46875 L 18.9375 21.0625 z M 10.90625 22.75 L 9.65625 23 L 9.03125 24.125 L 9.53125 25.3125 L 10.15625 25.65625 L 10.5 25.75 L 10.65625 25.78125 L 11.6875 25.9375 L 11.84375 25.9375 L 12.4375 25.96875 L 13.625 25.46875 L 14 24.25 L 13.25 23.1875 L 12.59375 22.96875 L 12 22.9375 L 11.25 22.84375 L 11.15625 22.8125 L 11.125 22.8125 L 10.90625 22.75 z"
                                      color="#000"
                                      overflow="visible"
                                      enableBackground="accumulate"
                                      fontFamily="Bitstream Vera Sans"
                                    />
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div
                            className="styles__cellBordersContainer--1CNfQ"
                            style={{
                              transform: "translateX(0px)",
                              borderRadius: 0
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className="react-grid-item styles__gridCell--18AbD"
                      style={{
                        padding: "1px 0px 0px",
                        top: 42,
                        left: 2,
                        width: 84,
                        height: 23,
                        position: "absolute"
                      }}
                    >
                      <div
                        data-id="i2"
                        className="styles__gridCellWrapper--1AQTk"
                      >
                        <div
                          className="styles__gridCell--2JKCu"
                          style={{
                            background: "rgba(242, 242, 242, 0)",
                            boxSizing: "border-box",
                            padding: 2,
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            zIndex: 0,
                            borderRadius: 0
                          }}
                        >
                          <div
                            className="styles__gridCellContent--1P2Ff"
                            style={{ width: "100%", height: "auto" }}
                          >
                            <div
                              data-id={0}
                              data-cellid="i2"
                              data-vg-test-label="text-element-0"
                              style={{ width: "100%" }}
                            >
                              <div>
                                <div
                                  id="draftEditor-3ee22676-0d09-46ca-acc8-59af1ae3a431"
                                  className="styles__cleanCssRoot--SYmyP"
                                  style={{ textAlign: "center" }}
                                >
                                  <div className="DraftEditor-root">
                                    <div
                                      className="DraftEditor-editorContainer"
                                      style={{ position: "initial" }}
                                    >
                                      <div
                                        aria-describedby="placeholder-euoa1"
                                        className="public-DraftEditor-content"
                                        contentEditable="false"
                                        spellCheck="true"
                                        style={{
                                          outline: "none",
                                          userSelect: "text",
                                          whiteSpace: "pre-wrap",
                                          overflowWrap: "break-word"
                                        }}
                                      >
                                        <div data-contents="true">
                                          <div
                                            className="draftjs-textalign-center"
                                            data-block="true"
                                            data-editor="euoa1"
                                            data-offset-key="default-0-0"
                                            style={{
                                              fontFamily:
                                                '"Barlow Condensed"',
                                              fontSize: 15,
                                              color: "rgb(255, 255, 255)",
                                              lineHeight: "1.2"
                                            }}
                                          >
                                            <div
                                              data-offset-key="default-0-0"
                                              className="public-DraftStyleDefault-block public-DraftStyleDefault-ltr"
                                            >
                                              <span
                                                data-offset-key="default-0-0"
                                                style={{
                                                  fontFamily:
                                                    '"Barlow Condensed"',
                                                  fontSize: 15,
                                                  color: "rgb(255, 255, 255)",
                                                  lineHeight: "1.2",
                                                  fontWeight: "normal",
                                                  fontStyle: "normal"
                                                }}
                                              >
                                                <span data-text="true">
                                                  Tacobell
                                                </span>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="styles__cellBordersContainer--1CNfQ"
                            style={{
                              transform: "translateX(0px)",
                              borderRadius: 0
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="styles__wrappedComponent--26Cp_ ignore-jqueryui-selectable vg-canvas-event-wrapper-component"
              data-key="3ee22676-0d09-46ca-acc8-59af1ae3a431/node_rKkFHOEzgO"
              style={{ pointerEvents: "auto" }}
            >
              <div
                data-widgettype="Diagram"
                data-id="node_rKkFHOEzgO"
                data-vg-test-label="smart-node-6"
                style={{
                  left: "465.005px",
                  top: "256.001px",
                  width: 125,
                  height: 125,
                  background: "none",
                  position: "relative",
                  borderRadius: 0,
                  transform: "none",
                  transformOrigin: "center center"
                }}
              >
                <svg
                  className="styles__decorator--2cpkw"
                  style={{
                    width: 131,
                    height: 131,
                    transform: "translate(-3px, -3px)"
                  }}
                >
                  <circle
                    cx="65.5"
                    cy="65.5"
                    r={64}
                    fill="rgb(81, 122, 128)"
                    stroke="rgb(245, 130, 31)"
                    strokeWidth={3}
                    strokeDasharray=""
                  />
                </svg>
                <div
                  style={{
                    top: "18.3058px",
                    left: "18.3058px",
                    width: "88.3883px",
                    height: "88.3883px",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center"
                  }}
                >
                  <div
                    className="react-grid-layout styles__root--37lJs"
                    style={{ height: "66.8291px" }}
                  >
                    <div
                      className="react-grid-item styles__gridCell--18AbD"
                      style={{
                        padding: "0px 0px 1px",
                        top: 2,
                        left: 2,
                        width: 84,
                        height: 40,
                        position: "absolute"
                      }}
                    >
                      <div
                        data-id="i1"
                        className="styles__gridCellWrapper--1AQTk"
                      >
                        <div
                          className="styles__gridCell--2JKCu"
                          style={{
                            background: "rgba(242, 242, 242, 0)",
                            boxSizing: "border-box",
                            padding: 2,
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            zIndex: 0,
                            borderRadius: 0
                          }}
                        >
                          <div
                            className="styles__gridCellContent--1P2Ff"
                            style={{ width: 80, height: 35 }}
                          >
                            <div
                              data-id={0}
                              data-cellid="i1"
                              data-vg-test-label="icon-element-0"
                            >
                              <div
                                className="styles__shape--29_P3"
                                style={{ width: 80, height: 35 }}
                              >
                                <svg
                                  width="100%"
                                  height="100%"
                                  fill="rgb(255, 255, 255)"
                                  xmlns="http://www.w3.org/2000/svg"
                                  pointerEvents="bounding-box"
                                  preserveAspectRatio="xMidYMin"
                                  style={{
                                    position: "unset",
                                    pointerEvents: "none"
                                  }}
                                  viewBox="2 2 19.9492 19.9063"
                                >
                                  <g>
                                    <path
                                      xmlns="http://www.w3.org/2000/svg"
                                      d="M 8.40625 2 L 6 2.3125 C 5.8 2.3125 5.6875 2.39375 5.6875 2.59375 L 5.6875 4.09375 C 5.2875 4.29375 4.9875 4.6125 4.6875 4.8125 L 3.3125 4.40625 C 3.2125 4.40625 3 4.39375 3 4.59375 L 2 6.8125 C 2 6.9125 1.9875 7.0875 2.1875 7.1875 L 3.59375 7.90625 L 3.59375 8.5 C 3.59375 8.7 3.6875 8.89375 3.6875 9.09375 L 2.59375 10.09375 C 2.49375 10.19375 2.49375 10.4 2.59375 10.5 L 4.09375 12.40625 C 4.19375 12.50625 4.4 12.6 4.5 12.5 L 5.8125 11.6875 C 6.0125 11.9875 6.4125 12.2125 6.8125 12.3125 L 7.09375 13.8125 C 7.09375 13.9125 7.30625 14 7.40625 14 L 9.8125 13.6875 C 10.0125 13.6875 10.09375 13.60625 10.09375 13.40625 L 10.09375 11.90625 C 10.49375 11.70625 10.79375 11.3875 11.09375 11.1875 L 12.59375 11.6875 C 12.69375 11.6875 12.9 11.7 13 11.5 L 13.90625 9.3125 C 14.00625 9.2125 13.9125 9.00625 13.8125 8.90625 L 12.3125 8.09375 L 12.3125 7.5 C 12.3125 7.3 12.1875 7.10625 12.1875 6.90625 L 13.3125 5.90625 C 13.4125 5.80625 13.4125 5.6 13.3125 5.5 L 11.8125 3.59375 C 11.7125 3.49375 11.50625 3.4 11.40625 3.5 L 10.09375 4.3125 C 9.89375 4.0125 9.49375 3.7875 9.09375 3.6875 L 8.6875 2.1875 C 8.6875 2.0875 8.60625 2 8.40625 2 z M 7.59375 5.6875 C 8.89375 5.4875 10.0875 6.5125 10.1875 7.8125 C 10.3875 9.0125 9.4875 10.2125 8.1875 10.3125 C 6.8875 10.5125 5.69375 9.4875 5.59375 8.1875 C 5.39375 6.9875 6.29375 5.7875 7.59375 5.6875 z M 17.09375 10.8125 L 14.90625 11 C 14.80625 11 14.6875 11.1125 14.6875 11.3125 L 14.6875 12.6875 C 14.3875 12.8875 14.1125 13.10625 13.8125 13.40625 L 12.5 13 C 12.4 13 12.1875 12.99375 12.1875 13.09375 L 11.3125 15.09375 C 11.2125 15.19375 11.30625 15.40625 11.40625 15.40625 L 12.59375 16.09375 L 12.59375 16.6875 C 12.59375 16.8875 12.6875 17.1125 12.6875 17.3125 L 11.59375 18.1875 C 11.49375 18.2875 11.49375 18.39375 11.59375 18.59375 L 12.90625 20.40625 C 13.00625 20.50625 13.1125 20.5 13.3125 20.5 L 14.5 19.8125 C 14.8 20.0125 15.2 20.2125 15.5 20.3125 L 15.8125 21.6875 C 15.8125 21.7875 15.99375 21.90625 16.09375 21.90625 L 18.3125 21.6875 C 18.4125 21.6875 18.5 21.60625 18.5 21.40625 L 18.5 20 C 18.8 19.8 19.10625 19.6125 19.40625 19.3125 L 20.6875 19.6875 C 20.7875 19.6875 21 19.69375 21 19.59375 L 21.90625 17.59375 C 22.00625 17.49375 21.9125 17.3125 21.8125 17.3125 L 20.59375 16.59375 L 20.59375 16 C 20.59375 15.8 20.5 15.60625 20.5 15.40625 L 21.59375 14.5 C 21.69375 14.4 21.69375 14.29375 21.59375 14.09375 L 20.3125 12.3125 C 20.2125 12.2125 20.10625 12.1875 19.90625 12.1875 L 18.6875 12.90625 C 18.3875 12.70625 17.9875 12.50625 17.6875 12.40625 L 17.40625 11 C 17.40625 10.9 17.19375 10.8125 17.09375 10.8125 z M 16.3125 14.40625 C 17.5125 14.30625 18.5875 15.1125 18.6875 16.3125 C 18.8875 17.5125 18.0125 18.4875 16.8125 18.6875 C 15.6125 18.7875 14.50625 18.0125 14.40625 16.8125 C 14.30625 15.6125 15.1125 14.50625 16.3125 14.40625 z"
                                    />
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div
                            className="styles__cellBordersContainer--1CNfQ"
                            style={{
                              transform: "translateX(0px)",
                              borderRadius: 0
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className="react-grid-item styles__gridCell--18AbD"
                      style={{
                        padding: "1px 0px 0px",
                        top: 42,
                        left: 2,
                        width: 84,
                        height: 23,
                        position: "absolute"
                      }}
                    >
                      <div
                        data-id="i2"
                        className="styles__gridCellWrapper--1AQTk"
                      >
                        <div
                          className="styles__gridCell--2JKCu"
                          style={{
                            background: "rgba(242, 242, 242, 0)",
                            boxSizing: "border-box",
                            padding: 2,
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            zIndex: 0,
                            borderRadius: 0
                          }}
                        >
                          <div
                            className="styles__gridCellContent--1P2Ff"
                            style={{ width: "100%", height: "auto" }}
                          >
                            <div
                              data-id={0}
                              data-cellid="i2"
                              data-vg-test-label="text-element-0"
                              style={{ width: "100%" }}
                            >
                              <div>
                                <div
                                  id="draftEditor-3ee22676-0d09-46ca-acc8-59af1ae3a431"
                                  className="styles__cleanCssRoot--SYmyP"
                                  style={{ textAlign: "center" }}
                                >
                                  <div className="DraftEditor-root">
                                    <div
                                      className="DraftEditor-editorContainer"
                                      style={{ position: "initial" }}
                                    >
                                      <div
                                        aria-describedby="placeholder-d0mgk"
                                        className="public-DraftEditor-content"
                                        contentEditable="false"
                                        spellCheck="true"
                                        style={{
                                          outline: "none",
                                          userSelect: "text",
                                          whiteSpace: "pre-wrap",
                                          overflowWrap: "break-word"
                                        }}
                                      >
                                        <div data-contents="true">
                                          <div
                                            className="draftjs-textalign-center"
                                            data-block="true"
                                            data-editor="d0mgk"
                                            data-offset-key="default-0-0"
                                            style={{
                                              fontFamily:
                                                '"Barlow Condensed"',
                                              fontSize: 15,
                                              color: "rgb(255, 255, 255)",
                                              lineHeight: "1.2"
                                            }}
                                          >
                                            <div
                                              data-offset-key="default-0-0"
                                              className="public-DraftStyleDefault-block public-DraftStyleDefault-ltr"
                                            >
                                              <span
                                                data-offset-key="default-0-0"
                                                style={{
                                                  fontFamily:
                                                    '"Barlow Condensed"',
                                                  fontSize: 15,
                                                  color: "rgb(255, 255, 255)",
                                                  lineHeight: "1.2",
                                                  fontWeight: "normal",
                                                  fontStyle: "normal"
                                                }}
                                              >
                                                <span data-text="true">
                                                  Dunkin
                                                </span>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="styles__cellBordersContainer--1CNfQ"
                            style={{
                              transform: "translateX(0px)",
                              borderRadius: 0
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="styles__wrappedComponent--26Cp_ ignore-jqueryui-selectable vg-canvas-event-wrapper-component"
              data-key="3ee22676-0d09-46ca-acc8-59af1ae3a431/node_FJmrZqxPNR"
              style={{ pointerEvents: "auto" }}
            >
              <div
                data-widgettype="Diagram"
                data-id="node_FJmrZqxPNR"
                data-vg-test-label="smart-node-7"
                style={{
                  left: "464.007px",
                  top: "405.001px",
                  width: 127,
                  height: 127,
                  background: "none",
                  position: "relative",
                  borderRadius: 0,
                  transform: "none",
                  transformOrigin: "center center"
                }}
              >
                <svg
                  className="styles__decorator--2cpkw"
                  style={{
                    width: 135,
                    height: 135,
                    transform: "translate(-4px, -4px)"
                  }}
                >
                  <circle
                    cx="67.5"
                    cy="67.5"
                    r="65.5"
                    fill="rgb(255, 255, 255)"
                    stroke="rgb(245, 130, 31)"
                    strokeWidth={4}
                    strokeDasharray=""
                  />
                </svg>
                <div
                  style={{
                    top: "18.687px",
                    left: "18.687px",
                    width: "89.626px",
                    height: "89.626px",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center"
                  }}
                >
                  <div
                    className="react-grid-layout styles__root--37lJs"
                    style={{ height: "69.2197px" }}
                  >
                    <div
                      className="react-grid-item styles__gridCell--18AbD"
                      style={{
                        padding: "0px 0px 1px",
                        top: 2,
                        left: 2,
                        width: 86,
                        height: 40,
                        position: "absolute"
                      }}
                    >
                      <div
                        data-id="i1"
                        className="styles__gridCellWrapper--1AQTk"
                      >
                        <div
                          className="styles__gridCell--2JKCu"
                          style={{
                            background: "rgba(242, 242, 242, 0)",
                            boxSizing: "border-box",
                            padding: 2,
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            zIndex: 0,
                            borderRadius: 0
                          }}
                        >
                          <div
                            className="styles__gridCellContent--1P2Ff"
                            style={{ width: 82, height: 35 }}
                          >
                            <div
                              data-id={0}
                              data-cellid="i1"
                              data-vg-test-label="icon-element-0"
                            >
                              <div
                                className="styles__shape--29_P3"
                                style={{ width: 82, height: 35 }}
                              >
                                <svg
                                  width="100%"
                                  height="100%"
                                  fill="rgb(81, 122, 128)"
                                  xmlns="http://www.w3.org/2000/svg"
                                  pointerEvents="bounding-box"
                                  preserveAspectRatio="xMidYMin"
                                  style={{
                                    position: "unset",
                                    pointerEvents: "none"
                                  }}
                                  viewBox="2 0 22 26"
                                >
                                  <g>
                                    <path
                                      xmlns="http://www.w3.org/2000/svg"
                                      style={{
                                        textIndent: 0,
                                        textAlign: "start",
                                        lineHeight: "normal",
                                        textTransform: "none",
                                        blockProgression: "tb",
                                        InkscapeFontSpecification:
                                          "Bitstream Vera Sans"
                                      }}
                                      d="M 10.8125 0 A 1.0001 1.0001 0 0 0 10 1 L 10 2 A 1.0001 1.0001 0 0 0 11 3 L 11 4.1875 C 5.8914889 5.1317164 2 9.6253217 2 15 C 2 21.057666 6.9464777 26 13 26 C 19.057749 26 24 21.056713 24 15 C 24 11.867727 22.677818 9.0385535 20.5625 7.03125 L 21.625 5.71875 A 1.0002485 1.0002485 0 0 0 21.46875 4.3125 L 20.25 3.375 A 1.0002485 1.0002485 0 0 0 20.1875 3.3125 A 1.0002485 1.0002485 0 0 0 18.84375 3.53125 L 17.65625 5.0625 C 16.821493 4.6700812 15.932002 4.3597183 15 4.1875 L 15 3 A 1.0001 1.0001 0 0 0 16 2 L 16 1 A 1.0001 1.0001 0 0 0 15 0 L 11 0 A 1.0001 1.0001 0 0 0 10.90625 0 A 1.0001 1.0001 0 0 0 10.8125 0 z M 13 7 C 17.43587 7 21 10.567022 21 15 C 21 19.435287 17.436251 23 13 23 C 8.5695223 23 5 19.434334 5 15 C 5 10.567976 8.5699039 7 13 7 z M 6.875 10.28125 C 6.69125 10.314 6.51925 10.42325 6.40625 10.59375 C 6.17725 10.93475 6.307 11.329 6.625 11.625 C 6.8622732 11.844873 9.6438809 14.107453 11.03125 15.25 C 11.155065 16.235715 11.98071 17 13 17 C 14.104569 17 15 16.104569 15 15 C 15 13.895431 14.104569 13 13 13 C 12.817056 13 12.637102 13.016492 12.46875 13.0625 C 10.836074 12.200371 7.5984027 10.4938 7.4375 10.40625 C 7.2585 10.30775 7.05875 10.2485 6.875 10.28125 z"
                                      color="#000"
                                      overflow="visible"
                                      enableBackground="accumulate"
                                      fontFamily="Bitstream Vera Sans"
                                    />
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div
                            className="styles__cellBordersContainer--1CNfQ"
                            style={{
                              transform: "translateX(0px)",
                              borderRadius: 0
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className="react-grid-item styles__gridCell--18AbD"
                      style={{
                        padding: "1px 0px 0px",
                        top: 42,
                        left: 2,
                        width: 86,
                        height: 25,
                        position: "absolute"
                      }}
                    >
                      <div
                        data-id="i2"
                        className="styles__gridCellWrapper--1AQTk"
                      >
                        <div
                          className="styles__gridCell--2JKCu"
                          style={{
                            background: "rgba(242, 242, 242, 0)",
                            boxSizing: "border-box",
                            padding: 2,
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            zIndex: 0,
                            borderRadius: 0
                          }}
                        >
                          <div
                            className="styles__gridCellContent--1P2Ff"
                            style={{ width: "100%", height: "auto" }}
                          >
                            <div
                              data-id={0}
                              data-cellid="i2"
                              data-vg-test-label="text-element-0"
                              style={{ width: "100%" }}
                            >
                              <div>
                                <div
                                  id="draftEditor-3ee22676-0d09-46ca-acc8-59af1ae3a431"
                                  className="styles__cleanCssRoot--SYmyP"
                                  style={{ textAlign: "center" }}
                                >
                                  <div className="DraftEditor-root">
                                    <div
                                      className="DraftEditor-editorContainer"
                                      style={{ position: "initial" }}
                                    >
                                      <div
                                        aria-describedby="placeholder-3u97q"
                                        className="public-DraftEditor-content"
                                        contentEditable="false"
                                        spellCheck="true"
                                        style={{
                                          outline: "none",
                                          userSelect: "text",
                                          whiteSpace: "pre-wrap",
                                          overflowWrap: "break-word"
                                        }}
                                      >
                                        <div data-contents="true">
                                          <div
                                            className="draftjs-textalign-center"
                                            data-block="true"
                                            data-editor="3u97q"
                                            data-offset-key="default-0-0"
                                            style={{
                                              fontFamily:
                                                '"Barlow Condensed"',
                                              fontSize: 17,
                                              color: "rgb(0, 0, 0)",
                                              lineHeight: "1.2"
                                            }}
                                          >
                                            <div
                                              data-offset-key="default-0-0"
                                              className="public-DraftStyleDefault-block public-DraftStyleDefault-ltr"
                                            >
                                              <span
                                                data-offset-key="default-0-0"
                                                style={{
                                                  fontWeight: "normal",
                                                  fontStyle: "normal"
                                                }}
                                              >
                                                <br data-text="true" />
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="styles__cellBordersContainer--1CNfQ"
                            style={{
                              transform: "translateX(0px)",
                              borderRadius: 0
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="styles__wrappedComponent--26Cp_ ignore-jqueryui-selectable vg-canvas-event-wrapper-component"
              data-key="3ee22676-0d09-46ca-acc8-59af1ae3a431/node_CG43Bp1d7z"
              style={{ pointerEvents: "auto" }}
            >
              <div
                data-widgettype="Diagram"
                data-id="node_CG43Bp1d7z"
                data-vg-test-label="smart-node-8"
                style={{
                  left: "370.762px",
                  top: "575.518px",
                  width: "80.5156px",
                  height: "auto",
                  background: "rgb(81, 122, 128)",
                  position: "relative",
                  borderRadius: 13,
                  transform: "none",
                  transformOrigin: "center center"
                }}
              >
                <div
                  className="styles__nodeBordersContainer--1j-sR"
                  style={{
                    borderRadius: 16,
                    borderWidth: 3,
                    borderStyle: "solid",
                    borderColor: "rgb(245, 130, 31)",
                    margin: "-3px 0px 0px -3px"
                  }}
                />
                <div
                  className="react-grid-layout styles__root--37lJs"
                  style={{ height: "78.8291px" }}
                >
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "0px 0px 1px",
                      top: 8,
                      left: 8,
                      width: 65,
                      height: 40,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i1"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 5,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: 55, height: 29 }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i1"
                            data-vg-test-label="icon-element-0"
                          >
                            <div
                              className="styles__shape--29_P3"
                              style={{ width: 55, height: 29 }}
                            >
                              <svg
                                width="100%"
                                height="100%"
                                fill="rgb(255, 255, 255)"
                                xmlns="http://www.w3.org/2000/svg"
                                pointerEvents="bounding-box"
                                preserveAspectRatio="xMidYMin"
                                style={{
                                  position: "unset",
                                  pointerEvents: "none"
                                }}
                                viewBox="1 1 24 24"
                              >
                                <g>
                                  <path
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{
                                      textIndent: 0,
                                      textAlign: "start",
                                      lineHeight: "normal",
                                      textTransform: "none",
                                      blockProgression: "tb",
                                      InkscapeFontSpecification:
                                        "Bitstream Vera Sans"
                                    }}
                                    d="M 13 1 C 6.3844277 1 1 6.3844277 1 13 C 1 19.615572 6.3844277 25 13 25 C 19.615572 25 25 19.615572 25 13 C 25 6.3844277 19.615572 1 13 1 z M 13 3 C 18.534692 3 23 7.4653079 23 13 C 23 18.534692 18.534692 23 13 23 C 7.4653079 23 3 18.534692 3 13 C 3 7.4653079 7.4653079 3 13 3 z M 17.1875 7.0625 C 17.0375 7.0875 16.9125 7.1625 16.8125 7.3125 L 11.90625 14.59375 L 9.59375 12.3125 C 9.39375 12.0125 9.0125 11.9875 8.8125 12.1875 L 7.90625 13.09375 C 7.70625 13.39375 7.70625 13.8 7.90625 14 L 11.40625 17.5 C 11.60625 17.6 11.8875 17.8125 12.1875 17.8125 C 12.3875 17.8125 12.70625 17.70625 12.90625 17.40625 L 18.90625 8.59375 C 19.10625 8.29375 18.99375 8.0125 18.59375 7.8125 L 17.59375 7.09375 C 17.49375 7.04375 17.3375 7.0375 17.1875 7.0625 z"
                                    color="#000"
                                    overflow="visible"
                                    enableBackground="accumulate"
                                    fontFamily="Bitstream Vera Sans"
                                  />
                                </g>
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "1px 0px 0px",
                      top: 48,
                      left: 8,
                      width: 65,
                      height: 23,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i2"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 2,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: "100%", height: "auto" }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i2"
                            data-vg-test-label="text-element-0"
                            style={{ width: "100%" }}
                          >
                            <div>
                              <div
                                id="draftEditor-3ee22676-0d09-46ca-acc8-59af1ae3a431"
                                className="styles__cleanCssRoot--SYmyP"
                                style={{ textAlign: "center" }}
                              >
                                <div className="DraftEditor-root">
                                  <div
                                    className="DraftEditor-editorContainer"
                                    style={{ position: "initial" }}
                                  >
                                    <div
                                      aria-describedby="placeholder-cc0nd"
                                      className="public-DraftEditor-content"
                                      contentEditable="false"
                                      spellCheck="true"
                                      style={{
                                        outline: "none",
                                        userSelect: "text",
                                        whiteSpace: "pre-wrap",
                                        overflowWrap: "break-word"
                                      }}
                                    >
                                      <div data-contents="true">
                                        <div
                                          className="draftjs-textalign-center"
                                          data-block="true"
                                          data-editor="cc0nd"
                                          data-offset-key="default-0-0"
                                          style={{
                                            fontFamily: '"Barlow Condensed"',
                                            fontSize: 15,
                                            color: "rgb(255, 255, 255)",
                                            lineHeight: "1.2"
                                          }}
                                        >
                                          <div
                                            data-offset-key="default-0-0"
                                            className="public-DraftStyleDefault-block public-DraftStyleDefault-ltr"
                                          >
                                            <span
                                              data-offset-key="default-0-0"
                                              style={{
                                                fontFamily:
                                                  '"Barlow Condensed"',
                                                fontSize: 15,
                                                color: "rgb(255, 255, 255)",
                                                lineHeight: "1.2",
                                                fontWeight: "normal",
                                                fontStyle: "normal"
                                              }}
                                            >
                                              <span data-text="true">
                                                Crunchtime
                                              </span>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="styles__wrappedComponent--26Cp_ ignore-jqueryui-selectable vg-canvas-event-wrapper-component"
              data-key="3ee22676-0d09-46ca-acc8-59af1ae3a431/node_32N4HLnZ5C"
              style={{ pointerEvents: "auto" }}
            >
              <div
                data-widgettype="Diagram"
                data-id="node_32N4HLnZ5C"
                data-vg-test-label="smart-node-9"
                style={{
                  left: "489.528px",
                  top: "575.519px",
                  width: "80.5156px",
                  height: "auto",
                  background: "rgb(81, 122, 128)",
                  position: "relative",
                  borderRadius: 13,
                  transform: "none",
                  transformOrigin: "center center"
                }}
              >
                <div
                  className="styles__nodeBordersContainer--1j-sR"
                  style={{
                    borderRadius: 16,
                    borderWidth: 3,
                    borderStyle: "solid",
                    borderColor: "rgb(245, 130, 31)",
                    margin: "-3px 0px 0px -3px"
                  }}
                />
                <div
                  className="react-grid-layout styles__root--37lJs"
                  style={{ height: "78.8291px" }}
                >
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "0px 0px 1px",
                      top: 8,
                      left: 8,
                      width: 65,
                      height: 40,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i1"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 5,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: 55, height: 29 }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i1"
                            data-vg-test-label="icon-element-0"
                          >
                            <div
                              className="styles__shape--29_P3"
                              style={{ width: 55, height: 29 }}
                            >
                              <svg
                                width="100%"
                                height="100%"
                                fill="rgb(255, 255, 255)"
                                xmlns="http://www.w3.org/2000/svg"
                                pointerEvents="bounding-box"
                                preserveAspectRatio="xMidYMin"
                                style={{
                                  position: "unset",
                                  pointerEvents: "none"
                                }}
                                viewBox="2 5 28 25.0938"
                              >
                                <g>
                                  <path
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{
                                      textIndent: 0,
                                      textAlign: "start",
                                      lineHeight: "normal",
                                      textTransform: "none",
                                      blockProgression: "tb",
                                      InkscapeFontSpecification:
                                        "Bitstream Vera Sans"
                                    }}
                                    d="M 2 5 L 2 6 L 2 24 L 2 25 L 3 25 L 7 25 L 7 28 L 7 30.09375 L 8.625 28.78125 L 13.34375 25 L 29 25 L 30 25 L 30 24 L 30 6 L 30 5 L 29 5 L 3 5 L 2 5 z M 4 7 L 28 7 L 28 23 L 13 23 L 12.65625 23 L 12.375 23.21875 L 9 25.90625 L 9 24 L 9 23 L 8 23 L 4 23 L 4 7 z M 8 12 L 8 14 L 24 14 L 24 12 L 8 12 z M 8 16 L 8 18 L 20 18 L 20 16 L 8 16 z"
                                    color="#000"
                                    overflow="visible"
                                    enableBackground="accumulate"
                                    fontFamily="Bitstream Vera Sans"
                                  />
                                </g>
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "1px 0px 0px",
                      top: 48,
                      left: 8,
                      width: 65,
                      height: 23,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i2"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 2,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: "100%", height: "auto" }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i2"
                            data-vg-test-label="text-element-0"
                            style={{ width: "100%" }}
                          >
                            <div>
                              <div
                                id="draftEditor-3ee22676-0d09-46ca-acc8-59af1ae3a431"
                                className="styles__cleanCssRoot--SYmyP"
                                style={{ textAlign: "center" }}
                              >
                                <div className="DraftEditor-root">
                                  <div
                                    className="DraftEditor-editorContainer"
                                    style={{ position: "initial" }}
                                  >
                                    <div
                                      aria-describedby="placeholder-326u0"
                                      className="public-DraftEditor-content"
                                      contentEditable="false"
                                      spellCheck="true"
                                      style={{
                                        outline: "none",
                                        userSelect: "text",
                                        whiteSpace: "pre-wrap",
                                        overflowWrap: "break-word"
                                      }}
                                    >
                                      <div data-contents="true">
                                        <div
                                          className="draftjs-textalign-center"
                                          data-block="true"
                                          data-editor="326u0"
                                          data-offset-key="default-0-0"
                                          style={{
                                            fontFamily: '"Barlow Condensed"',
                                            fontSize: 15,
                                            color: "rgb(255, 255, 255)",
                                            lineHeight: "1.2"
                                          }}
                                        >
                                          <div
                                            data-offset-key="default-0-0"
                                            className="public-DraftStyleDefault-block public-DraftStyleDefault-ltr"
                                          >
                                            <span
                                              data-offset-key="default-0-0"
                                              style={{
                                                fontFamily:
                                                  '"Barlow Condensed"',
                                                fontSize: 15,
                                                color: "rgb(255, 255, 255)",
                                                lineHeight: "1.2",
                                                fontWeight: "normal",
                                                fontStyle: "normal"
                                              }}
                                            >
                                              <span data-text="true">
                                                NDCP
                                              </span>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="styles__wrappedComponent--26Cp_ ignore-jqueryui-selectable vg-canvas-event-wrapper-component"
              data-key="3ee22676-0d09-46ca-acc8-59af1ae3a431/node_SlJby8yeLU"
              style={{ pointerEvents: "auto" }}
            >
              <div
                data-widgettype="Diagram"
                data-id="node_SlJby8yeLU"
                data-vg-test-label="smart-node-10"
                style={{
                  left: "609.666px",
                  top: "575.52px",
                  width: "81.875px",
                  height: "auto",
                  background: "rgb(81, 122, 128)",
                  position: "relative",
                  borderRadius: 13,
                  transform: "none",
                  transformOrigin: "center center"
                }}
              >
                <div
                  className="styles__nodeBordersContainer--1j-sR"
                  style={{
                    borderRadius: 16,
                    borderWidth: 3,
                    borderStyle: "solid",
                    borderColor: "rgb(245, 130, 31)",
                    margin: "-3px 0px 0px -3px"
                  }}
                />
                <div
                  className="react-grid-layout styles__root--37lJs"
                  style={{ height: "78.8291px" }}
                >
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "0px 0px 1px",
                      top: 8,
                      left: 8,
                      width: 66,
                      height: 40,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i1"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 5,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: 56, height: 29 }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i1"
                            data-vg-test-label="icon-element-0"
                          >
                            <div
                              className="styles__shape--29_P3"
                              style={{ width: 56, height: 29 }}
                            >
                              <svg
                                width="100%"
                                height="100%"
                                fill="rgb(255, 255, 255)"
                                xmlns="http://www.w3.org/2000/svg"
                                pointerEvents="bounding-box"
                                preserveAspectRatio="xMidYMin"
                                style={{
                                  position: "unset",
                                  pointerEvents: "none"
                                }}
                                viewBox="2 2 20 20"
                              >
                                <g>
                                  <path
                                    xmlns="http://www.w3.org/2000/svg"
                                    d="M 12 2 C 6.5 2 2 6.5 2 12 C 2 17.5 6.5 22 12 22 C 17.5 22 22 17.5 22 12 C 22 6.5 17.5 2 12 2 z M 12 4 C 16.4 4 20 7.6 20 12 C 20 16.4 16.4 20 12 20 C 7.6 20 4 16.4 4 12 C 4 7.6 7.6 4 12 4 z M 11.90625 7 C 8.60625 7 9 10 9 10 L 11 10 C 11 8.6 11.7 8.5 12 8.5 C 12.8 8.5 13 9.4125 13 9.8125 C 13 11.9125 11 11.4 11 14 L 13 14 C 13 12.3 15 12.2125 15 9.8125 C 15 8.9125 14.50625 7 11.90625 7 z M 11 15 L 11 17 L 13 17 L 13 15 L 11 15 z"
                                  />
                                </g>
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "1px 0px 0px",
                      top: 48,
                      left: 8,
                      width: 66,
                      height: 23,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i2"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 2,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: "100%", height: "auto" }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i2"
                            data-vg-test-label="text-element-0"
                            style={{ width: "100%" }}
                          >
                            <div>
                              <div
                                id="draftEditor-3ee22676-0d09-46ca-acc8-59af1ae3a431"
                                className="styles__cleanCssRoot--SYmyP"
                                style={{ textAlign: "center" }}
                              >
                                <div className="DraftEditor-root">
                                  <div
                                    className="DraftEditor-editorContainer"
                                    style={{ position: "initial" }}
                                  >
                                    <div
                                      aria-describedby="placeholder-61pio"
                                      className="public-DraftEditor-content"
                                      contentEditable="false"
                                      spellCheck="true"
                                      style={{
                                        outline: "none",
                                        userSelect: "text",
                                        whiteSpace: "pre-wrap",
                                        overflowWrap: "break-word"
                                      }}
                                    >
                                      <div data-contents="true">
                                        <div
                                          className="draftjs-textalign-center"
                                          data-block="true"
                                          data-editor="61pio"
                                          data-offset-key="default-0-0"
                                          style={{
                                            fontFamily: '"Barlow Condensed"',
                                            fontSize: 15,
                                            color: "rgb(255, 255, 255)",
                                            lineHeight: "1.2"
                                          }}
                                        >
                                          <div
                                            data-offset-key="default-0-0"
                                            className="public-DraftStyleDefault-block public-DraftStyleDefault-ltr"
                                          >
                                            <span
                                              data-offset-key="default-0-0"
                                              style={{
                                                fontFamily:
                                                  '"Barlow Condensed"',
                                                fontSize: 15,
                                                color: "rgb(255, 255, 255)",
                                                lineHeight: "1.2",
                                                fontWeight: "normal",
                                                fontStyle: "normal"
                                              }}
                                            >
                                              <span data-text="true">
                                                Franchise
                                              </span>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="styles__wrappedComponent--26Cp_ ignore-jqueryui-selectable vg-canvas-event-wrapper-component"
              data-key="3ee22676-0d09-46ca-acc8-59af1ae3a431/node_PZ1l3qUtWx"
              style={{ pointerEvents: "auto" }}
            >
              <div
                data-widgettype="Diagram"
                data-id="node_PZ1l3qUtWx"
                data-vg-test-label="smart-node-11"
                style={{
                  left: "130.149px",
                  top: "72.7623px",
                  width: 111,
                  height: 111,
                  background: "none",
                  position: "relative",
                  borderRadius: 0,
                  transform: "none",
                  transformOrigin: "center center"
                }}
              >
                <svg
                  className="styles__decorator--2cpkw"
                  style={{
                    width: 117,
                    height: 117,
                    transform: "translate(-3px, -3px)"
                  }}
                >
                  <circle
                    cx="58.50012"
                    cy="58.50012"
                    r="57.00012"
                    fill="rgb(214, 102, 51)"
                    stroke="rgb(255, 255, 255)"
                    strokeWidth={3}
                    strokeDasharray=""
                  />
                </svg>
                <div
                  style={{
                    top: "11.9073px",
                    left: "11.9073px",
                    width: "87.1857px",
                    height: "87.1857px",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center"
                  }}
                >
                  <div
                    className="react-grid-layout styles__root--37lJs"
                    style={{ height: "67.9355px" }}
                  >
                    <div
                      className="react-grid-item styles__gridCell--18AbD"
                      style={{
                        padding: "0px 0px 1px",
                        top: 2,
                        left: 2,
                        width: 83,
                        height: 41,
                        position: "absolute"
                      }}
                    >
                      <div
                        data-id="i1"
                        className="styles__gridCellWrapper--1AQTk"
                      >
                        <div
                          className="styles__gridCell--2JKCu"
                          style={{
                            background: "rgba(242, 242, 242, 0)",
                            boxSizing: "border-box",
                            padding: 2,
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            zIndex: 0,
                            borderRadius: 0
                          }}
                        >
                          <div
                            className="styles__gridCellContent--1P2Ff"
                            style={{ width: 79, height: 36 }}
                          >
                            <div
                              data-id={0}
                              data-cellid="i1"
                              data-vg-test-label="icon-element-0"
                            >
                              <div
                                className="styles__shape--29_P3"
                                style={{ width: 79, height: 36 }}
                              >
                                <svg
                                  width="100%"
                                  height="100%"
                                  fill="rgb(255, 255, 255)"
                                  xmlns="http://www.w3.org/2000/svg"
                                  pointerEvents="bounding-box"
                                  preserveAspectRatio="xMidYMin"
                                  style={{
                                    position: "unset",
                                    pointerEvents: "none"
                                  }}
                                  viewBox="2 0 22 26"
                                >
                                  <g>
                                    <path
                                      xmlns="http://www.w3.org/2000/svg"
                                      style={{
                                        textIndent: 0,
                                        textAlign: "start",
                                        lineHeight: "normal",
                                        textTransform: "none",
                                        blockProgression: "tb",
                                        InkscapeFontSpecification:
                                          "Bitstream Vera Sans"
                                      }}
                                      d="M 10.8125 0 A 1.0001 1.0001 0 0 0 10 1 L 10 2 A 1.0001 1.0001 0 0 0 11 3 L 11 4.1875 C 5.8914889 5.1317164 2 9.6253217 2 15 C 2 21.057666 6.9464777 26 13 26 C 19.057749 26 24 21.056713 24 15 C 24 11.867727 22.677818 9.0385535 20.5625 7.03125 L 21.625 5.71875 A 1.0002485 1.0002485 0 0 0 21.46875 4.3125 L 20.25 3.375 A 1.0002485 1.0002485 0 0 0 20.1875 3.3125 A 1.0002485 1.0002485 0 0 0 18.84375 3.53125 L 17.65625 5.0625 C 16.821493 4.6700812 15.932002 4.3597183 15 4.1875 L 15 3 A 1.0001 1.0001 0 0 0 16 2 L 16 1 A 1.0001 1.0001 0 0 0 15 0 L 11 0 A 1.0001 1.0001 0 0 0 10.90625 0 A 1.0001 1.0001 0 0 0 10.8125 0 z M 13 7 C 17.43587 7 21 10.567022 21 15 C 21 19.435287 17.436251 23 13 23 C 8.5695223 23 5 19.434334 5 15 C 5 10.567976 8.5699039 7 13 7 z M 6.875 10.28125 C 6.69125 10.314 6.51925 10.42325 6.40625 10.59375 C 6.17725 10.93475 6.307 11.329 6.625 11.625 C 6.8622732 11.844873 9.6438809 14.107453 11.03125 15.25 C 11.155065 16.235715 11.98071 17 13 17 C 14.104569 17 15 16.104569 15 15 C 15 13.895431 14.104569 13 13 13 C 12.817056 13 12.637102 13.016492 12.46875 13.0625 C 10.836074 12.200371 7.5984027 10.4938 7.4375 10.40625 C 7.2585 10.30775 7.05875 10.2485 6.875 10.28125 z"
                                      color="#000"
                                      overflow="visible"
                                      enableBackground="accumulate"
                                      fontFamily="Bitstream Vera Sans"
                                    />
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div
                            className="styles__cellBordersContainer--1CNfQ"
                            style={{
                              transform: "translateX(0px)",
                              borderRadius: 0
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className="react-grid-item styles__gridCell--18AbD"
                      style={{
                        padding: "1px 0px 0px",
                        top: 43,
                        left: 2,
                        width: 83,
                        height: 23,
                        position: "absolute"
                      }}
                    >
                      <div
                        data-id="i2"
                        className="styles__gridCellWrapper--1AQTk"
                      >
                        <div
                          className="styles__gridCell--2JKCu"
                          style={{
                            background: "rgba(242, 242, 242, 0)",
                            boxSizing: "border-box",
                            padding: 2,
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            zIndex: 0,
                            borderRadius: 0
                          }}
                        >
                          <div
                            className="styles__gridCellContent--1P2Ff"
                            style={{ width: "100%", height: "auto" }}
                          >
                            <div
                              data-id={0}
                              data-cellid="i2"
                              data-vg-test-label="text-element-0"
                              style={{ width: "100%" }}
                            >
                              <div>
                                <div
                                  id="draftEditor-3ee22676-0d09-46ca-acc8-59af1ae3a431"
                                  className="styles__cleanCssRoot--SYmyP"
                                  style={{ textAlign: "center" }}
                                >
                                  <div className="DraftEditor-root">
                                    <div
                                      className="DraftEditor-editorContainer"
                                      style={{ position: "initial" }}
                                    >
                                      <div
                                        aria-describedby="placeholder-53l2e"
                                        className="public-DraftEditor-content"
                                        contentEditable="false"
                                        spellCheck="true"
                                        style={{
                                          outline: "none",
                                          userSelect: "text",
                                          whiteSpace: "pre-wrap",
                                          overflowWrap: "break-word"
                                        }}
                                      >
                                        <div data-contents="true">
                                          <div
                                            className="draftjs-textalign-center"
                                            data-block="true"
                                            data-editor="53l2e"
                                            data-offset-key="default-0-0"
                                            style={{
                                              fontFamily:
                                                '"Barlow Condensed"',
                                              fontSize: 15,
                                              color: "rgb(255, 255, 255)",
                                              lineHeight: "1.2"
                                            }}
                                          >
                                            <div
                                              data-offset-key="default-0-0"
                                              className="public-DraftStyleDefault-block public-DraftStyleDefault-ltr"
                                            >
                                              <span
                                                data-offset-key="default-0-0"
                                                style={{
                                                  fontFamily:
                                                    '"Barlow Condensed"',
                                                  fontSize: 15,
                                                  color: "rgb(255, 255, 255)",
                                                  lineHeight: "1.2",
                                                  fontWeight: "normal",
                                                  fontStyle: "normal"
                                                }}
                                              >
                                                <span data-text="true">
                                                  Google Drive
                                                </span>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="styles__cellBordersContainer--1CNfQ"
                            style={{
                              transform: "translateX(0px)",
                              borderRadius: 0
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="styles__wrappedComponent--26Cp_ ignore-jqueryui-selectable vg-canvas-event-wrapper-component"
              data-key="3ee22676-0d09-46ca-acc8-59af1ae3a431/node_cH7HwBT9q2"
              style={{ pointerEvents: "auto" }}
            >
              <div
                data-widgettype="Diagram"
                data-id="node_cH7HwBT9q2"
                data-vg-test-label="smart-node-12"
                style={{
                  left: "7.4857px",
                  top: "307.005px",
                  width: "93.2969px",
                  height: "auto",
                  background: "rgb(81, 122, 128)",
                  position: "relative",
                  borderRadius: 13,
                  transform: "none",
                  transformOrigin: "center center"
                }}
              >
                <div
                  className="styles__nodeBordersContainer--1j-sR"
                  style={{
                    borderRadius: 16,
                    borderWidth: 3,
                    borderStyle: "solid",
                    borderColor: "rgb(104, 42, 141)",
                    margin: "-3px 0px 0px -3px"
                  }}
                />
                <div
                  className="react-grid-layout styles__root--37lJs"
                  style={{ height: "88.7775px" }}
                >
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "0px 0px 1px",
                      top: 9,
                      left: 9,
                      width: 75,
                      height: 45,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i1"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 6,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: 63, height: 32 }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i1"
                            data-vg-test-label="icon-element-0"
                          >
                            <div
                              className="styles__shape--29_P3"
                              style={{ width: 63, height: 32 }}
                            >
                              <svg
                                width="100%"
                                height="100%"
                                fill="rgb(255, 255, 255)"
                                xmlns="http://www.w3.org/2000/svg"
                                pointerEvents="bounding-box"
                                preserveAspectRatio="xMidYMin"
                                style={{
                                  position: "unset",
                                  pointerEvents: "none"
                                }}
                                viewBox="1 0.0898 24.0586 25.8789"
                              >
                                <g>
                                  <path
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{
                                      textIndent: 0,
                                      textAlign: "start",
                                      lineHeight: "normal",
                                      textTransform: "none",
                                      blockProgression: "tb",
                                      InkscapeFontSpecification:
                                        "Bitstream Vera Sans"
                                    }}
                                    d="M 20.84375 0.09375 C 20.63125 0.06875 20.3875 0.2 20.1875 0.5 L 18.21875 3.1875 C 16.648399 2.4393084 14.889565 2 13 2 C 6.3896552 2 1 7.3896552 1 14 L 1 14.0625 A 1.50015 1.50015 0 0 0 1 14.1875 L 1.0625 15.15625 L 1.0625 15.3125 L 1.21875 16.21875 L 1.9375 17.28125 L 3.21875 17.40625 L 4.125 16.46875 L 4.1875 15.75 L 4.0625 15 L 4 14.09375 A 1.50015 1.50015 0 0 0 4 14 L 4 13.9375 C 4.0331912 8.9767822 8.031112 5 13 5 C 14.234955 5 15.373423 5.2111266 16.40625 5.625 L 14.8125 7.8125 C 14.4125 8.4125 14.4 8.80625 15 8.90625 L 24.1875 10.1875 C 24.8875 10.2875 25.2 9.8875 25 9.1875 L 21.40625 0.59375 C 21.25625 0.29375 21.05625 0.11875 20.84375 0.09375 z M 23.21875 15.4375 L 22 15.90625 L 21.65625 16.5 L 21.5 17 L 21.28125 17.59375 L 21.25 17.59375 L 21 18.125 L 20.96875 19.40625 L 21.9375 20.25 L 23.21875 20 L 23.6875 19.46875 L 23.9375 18.96875 L 24 18.84375 L 24.34375 17.96875 L 24.375 17.84375 L 24.53125 17.375 L 24.3125 16.09375 L 23.21875 15.4375 z M 4.8125 19 L 3.625 19.5 L 3.28125 20.75 L 3.5625 21.375 L 3.6875 21.5625 L 3.78125 21.6875 L 4.46875 22.4375 L 4.5625 22.53125 L 5.125 23.03125 L 6.375 23.40625 L 7.4375 22.6875 L 7.53125 21.40625 L 7.15625 20.8125 L 6.6875 20.40625 L 6.625 20.34375 L 6.59375 20.3125 L 6.09375 19.78125 L 6.03125 19.6875 L 6 19.65625 L 5.96875 19.59375 L 4.8125 19 z M 18.9375 21.0625 L 18.28125 21.28125 L 17.6875 21.6875 L 17.59375 21.75 L 17 22.0625 L 16.96875 22.09375 L 16.875 22.125 L 16.78125 22.15625 L 15.9375 23.125 L 16.15625 24.40625 L 17.28125 25.03125 L 17.96875 24.90625 L 18.1875 24.8125 L 18.3125 24.75 L 19.125 24.3125 L 19.25 24.25 L 19.9375 23.78125 L 20.59375 22.6875 L 20.15625 21.46875 L 18.9375 21.0625 z M 10.90625 22.75 L 9.65625 23 L 9.03125 24.125 L 9.53125 25.3125 L 10.15625 25.65625 L 10.5 25.75 L 10.65625 25.78125 L 11.6875 25.9375 L 11.84375 25.9375 L 12.4375 25.96875 L 13.625 25.46875 L 14 24.25 L 13.25 23.1875 L 12.59375 22.96875 L 12 22.9375 L 11.25 22.84375 L 11.15625 22.8125 L 11.125 22.8125 L 10.90625 22.75 z"
                                    color="#000"
                                    overflow="visible"
                                    enableBackground="accumulate"
                                    fontFamily="Bitstream Vera Sans"
                                  />
                                </g>
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "1px 0px 0px",
                      top: 54,
                      left: 9,
                      width: 75,
                      height: 25,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i2"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 2,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: "100%", height: "auto" }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i2"
                            data-vg-test-label="text-element-0"
                            style={{ width: "100%" }}
                          >
                            <div>
                              <div
                                id="draftEditor-3ee22676-0d09-46ca-acc8-59af1ae3a431"
                                className="styles__cleanCssRoot--SYmyP"
                                style={{ textAlign: "center" }}
                              >
                                <div className="DraftEditor-root">
                                  <div
                                    className="DraftEditor-editorContainer"
                                    style={{ position: "initial" }}
                                  >
                                    <div
                                      aria-describedby="placeholder-fa6cd"
                                      className="public-DraftEditor-content"
                                      contentEditable="false"
                                      spellCheck="true"
                                      style={{
                                        outline: "none",
                                        userSelect: "text",
                                        whiteSpace: "pre-wrap",
                                        overflowWrap: "break-word"
                                      }}
                                    >
                                      <div data-contents="true">
                                        <div
                                          className="draftjs-textalign-center"
                                          data-block="true"
                                          data-editor="fa6cd"
                                          data-offset-key="default-0-0"
                                          style={{
                                            fontFamily: '"Barlow Condensed"',
                                            fontSize: 17,
                                            color: "rgb(255, 255, 255)",
                                            lineHeight: "1.2"
                                          }}
                                        >
                                          <div
                                            data-offset-key="default-0-0"
                                            className="public-DraftStyleDefault-block public-DraftStyleDefault-ltr"
                                          >
                                            <span
                                              data-offset-key="default-0-0"
                                              style={{
                                                fontFamily:
                                                  '"Barlow Condensed"',
                                                fontSize: 17,
                                                color: "rgb(255, 255, 255)",
                                                lineHeight: "1.2",
                                                fontWeight: "normal",
                                                fontStyle: "normal"
                                              }}
                                            >
                                              <span data-text="true">
                                                Delegate
                                              </span>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="styles__wrappedComponent--26Cp_ ignore-jqueryui-selectable vg-canvas-event-wrapper-component"
              data-key="3ee22676-0d09-46ca-acc8-59af1ae3a431/node_WlpErBk64K"
              style={{ pointerEvents: "auto" }}
            >
              <div
                data-widgettype="Diagram"
                data-id="node_WlpErBk64K"
                data-vg-test-label="smart-node-13"
                style={{
                  left: "251.154px",
                  top: "575.516px",
                  width: "80.5156px",
                  height: "auto",
                  background: "rgb(81, 122, 128)",
                  position: "relative",
                  borderRadius: 13,
                  transform: "none",
                  transformOrigin: "center center"
                }}
              >
                <div
                  className="styles__nodeBordersContainer--1j-sR"
                  style={{
                    borderRadius: 16,
                    borderWidth: 3,
                    borderStyle: "solid",
                    borderColor: "rgb(245, 130, 31)",
                    margin: "-3px 0px 0px -3px"
                  }}
                />
                <div
                  className="react-grid-layout styles__root--37lJs"
                  style={{ height: "78.8291px" }}
                >
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "0px 0px 1px",
                      top: 8,
                      left: 8,
                      width: 65,
                      height: 40,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i1"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 5,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: 55, height: 29 }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i1"
                            data-vg-test-label="icon-element-0"
                          >
                            <div
                              className="styles__shape--29_P3"
                              style={{ width: 55, height: 29 }}
                            >
                              <svg
                                width="100%"
                                height="100%"
                                fill="rgb(255, 255, 255)"
                                xmlns="http://www.w3.org/2000/svg"
                                pointerEvents="bounding-box"
                                preserveAspectRatio="xMidYMin"
                                style={{
                                  position: "unset",
                                  pointerEvents: "none"
                                }}
                                viewBox="1 1 24 24"
                              >
                                <g>
                                  <path
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{
                                      textIndent: 0,
                                      textAlign: "start",
                                      lineHeight: "normal",
                                      textTransform: "none",
                                      blockProgression: "tb",
                                      InkscapeFontSpecification:
                                        "Bitstream Vera Sans"
                                    }}
                                    d="M 13 1 C 6.3844277 1 1 6.3844277 1 13 C 1 19.615572 6.3844277 25 13 25 C 19.615572 25 25 19.615572 25 13 C 25 6.3844277 19.615572 1 13 1 z M 13 3 C 18.534692 3 23 7.4653079 23 13 C 23 18.534692 18.534692 23 13 23 C 7.4653079 23 3 18.534692 3 13 C 3 7.4653079 7.4653079 3 13 3 z M 17.1875 7.0625 C 17.0375 7.0875 16.9125 7.1625 16.8125 7.3125 L 11.90625 14.59375 L 9.59375 12.3125 C 9.39375 12.0125 9.0125 11.9875 8.8125 12.1875 L 7.90625 13.09375 C 7.70625 13.39375 7.70625 13.8 7.90625 14 L 11.40625 17.5 C 11.60625 17.6 11.8875 17.8125 12.1875 17.8125 C 12.3875 17.8125 12.70625 17.70625 12.90625 17.40625 L 18.90625 8.59375 C 19.10625 8.29375 18.99375 8.0125 18.59375 7.8125 L 17.59375 7.09375 C 17.49375 7.04375 17.3375 7.0375 17.1875 7.0625 z"
                                    color="#000"
                                    overflow="visible"
                                    enableBackground="accumulate"
                                    fontFamily="Bitstream Vera Sans"
                                  />
                                </g>
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "1px 0px 0px",
                      top: 48,
                      left: 8,
                      width: 65,
                      height: 23,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i2"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 2,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: "100%", height: "auto" }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i2"
                            data-vg-test-label="text-element-0"
                            style={{ width: "100%" }}
                          >
                            <div>
                              <div
                                id="draftEditor-3ee22676-0d09-46ca-acc8-59af1ae3a431"
                                className="styles__cleanCssRoot--SYmyP"
                                style={{ textAlign: "center" }}
                              >
                                <div className="DraftEditor-root">
                                  <div
                                    className="DraftEditor-editorContainer"
                                    style={{ position: "initial" }}
                                  >
                                    <div
                                      aria-describedby="placeholder-2ma1k"
                                      className="public-DraftEditor-content"
                                      contentEditable="false"
                                      spellCheck="true"
                                      style={{
                                        outline: "none",
                                        userSelect: "text",
                                        whiteSpace: "pre-wrap",
                                        overflowWrap: "break-word"
                                      }}
                                    >
                                      <div data-contents="true">
                                        <div
                                          className="draftjs-textalign-center"
                                          data-block="true"
                                          data-editor="2ma1k"
                                          data-offset-key="default-0-0"
                                          style={{
                                            fontFamily: '"Barlow Condensed"',
                                            fontSize: 15,
                                            color: "rgb(255, 255, 255)",
                                            lineHeight: "1.2"
                                          }}
                                        >
                                          <div
                                            data-offset-key="default-0-0"
                                            className="public-DraftStyleDefault-block public-DraftStyleDefault-ltr"
                                          >
                                            <span
                                              data-offset-key="default-0-0"
                                              style={{
                                                fontFamily:
                                                  '"Barlow Condensed"',
                                                fontSize: 15,
                                                color: "rgb(255, 255, 255)",
                                                lineHeight: "1.2",
                                                fontWeight: "normal",
                                                fontStyle: "normal"
                                              }}
                                            >
                                              <span data-text="true">
                                                JERA
                                              </span>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="styles__wrappedComponent--26Cp_ ignore-jqueryui-selectable vg-canvas-event-wrapper-component"
              data-key="3ee22676-0d09-46ca-acc8-59af1ae3a431/node_PJr735w4bY"
              style={{ pointerEvents: "auto" }}
            >
              <div
                data-widgettype="Diagram"
                data-id="node_PJr735w4bY"
                data-vg-test-label="smart-node-14"
                style={{
                  left: "30.5164px",
                  top: "414.386px",
                  width: "93.2969px",
                  height: "auto",
                  background: "rgb(81, 122, 128)",
                  position: "relative",
                  borderRadius: 13,
                  transform: "none",
                  transformOrigin: "center center"
                }}
              >
                <div
                  className="styles__nodeBordersContainer--1j-sR"
                  style={{
                    borderRadius: 16,
                    borderWidth: 3,
                    borderStyle: "solid",
                    borderColor: "rgb(104, 42, 141)",
                    margin: "-3px 0px 0px -3px"
                  }}
                />
                <div
                  className="react-grid-layout styles__root--37lJs"
                  style={{ height: "88.7775px" }}
                >
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "0px 0px 1px",
                      top: 9,
                      left: 9,
                      width: 75,
                      height: 45,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i1"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 6,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: 63, height: 32 }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i1"
                            data-vg-test-label="icon-element-0"
                          >
                            <div
                              className="styles__shape--29_P3"
                              style={{ width: 63, height: 32 }}
                            >
                              <svg
                                width="100%"
                                height="100%"
                                fill="rgb(255, 255, 255)"
                                xmlns="http://www.w3.org/2000/svg"
                                pointerEvents="bounding-box"
                                preserveAspectRatio="xMidYMin"
                                style={{
                                  position: "unset",
                                  pointerEvents: "none"
                                }}
                                viewBox="1 0.0898 24.0586 25.8789"
                              >
                                <g>
                                  <path
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{
                                      textIndent: 0,
                                      textAlign: "start",
                                      lineHeight: "normal",
                                      textTransform: "none",
                                      blockProgression: "tb",
                                      InkscapeFontSpecification:
                                        "Bitstream Vera Sans"
                                    }}
                                    d="M 20.84375 0.09375 C 20.63125 0.06875 20.3875 0.2 20.1875 0.5 L 18.21875 3.1875 C 16.648399 2.4393084 14.889565 2 13 2 C 6.3896552 2 1 7.3896552 1 14 L 1 14.0625 A 1.50015 1.50015 0 0 0 1 14.1875 L 1.0625 15.15625 L 1.0625 15.3125 L 1.21875 16.21875 L 1.9375 17.28125 L 3.21875 17.40625 L 4.125 16.46875 L 4.1875 15.75 L 4.0625 15 L 4 14.09375 A 1.50015 1.50015 0 0 0 4 14 L 4 13.9375 C 4.0331912 8.9767822 8.031112 5 13 5 C 14.234955 5 15.373423 5.2111266 16.40625 5.625 L 14.8125 7.8125 C 14.4125 8.4125 14.4 8.80625 15 8.90625 L 24.1875 10.1875 C 24.8875 10.2875 25.2 9.8875 25 9.1875 L 21.40625 0.59375 C 21.25625 0.29375 21.05625 0.11875 20.84375 0.09375 z M 23.21875 15.4375 L 22 15.90625 L 21.65625 16.5 L 21.5 17 L 21.28125 17.59375 L 21.25 17.59375 L 21 18.125 L 20.96875 19.40625 L 21.9375 20.25 L 23.21875 20 L 23.6875 19.46875 L 23.9375 18.96875 L 24 18.84375 L 24.34375 17.96875 L 24.375 17.84375 L 24.53125 17.375 L 24.3125 16.09375 L 23.21875 15.4375 z M 4.8125 19 L 3.625 19.5 L 3.28125 20.75 L 3.5625 21.375 L 3.6875 21.5625 L 3.78125 21.6875 L 4.46875 22.4375 L 4.5625 22.53125 L 5.125 23.03125 L 6.375 23.40625 L 7.4375 22.6875 L 7.53125 21.40625 L 7.15625 20.8125 L 6.6875 20.40625 L 6.625 20.34375 L 6.59375 20.3125 L 6.09375 19.78125 L 6.03125 19.6875 L 6 19.65625 L 5.96875 19.59375 L 4.8125 19 z M 18.9375 21.0625 L 18.28125 21.28125 L 17.6875 21.6875 L 17.59375 21.75 L 17 22.0625 L 16.96875 22.09375 L 16.875 22.125 L 16.78125 22.15625 L 15.9375 23.125 L 16.15625 24.40625 L 17.28125 25.03125 L 17.96875 24.90625 L 18.1875 24.8125 L 18.3125 24.75 L 19.125 24.3125 L 19.25 24.25 L 19.9375 23.78125 L 20.59375 22.6875 L 20.15625 21.46875 L 18.9375 21.0625 z M 10.90625 22.75 L 9.65625 23 L 9.03125 24.125 L 9.53125 25.3125 L 10.15625 25.65625 L 10.5 25.75 L 10.65625 25.78125 L 11.6875 25.9375 L 11.84375 25.9375 L 12.4375 25.96875 L 13.625 25.46875 L 14 24.25 L 13.25 23.1875 L 12.59375 22.96875 L 12 22.9375 L 11.25 22.84375 L 11.15625 22.8125 L 11.125 22.8125 L 10.90625 22.75 z"
                                    color="#000"
                                    overflow="visible"
                                    enableBackground="accumulate"
                                    fontFamily="Bitstream Vera Sans"
                                  />
                                </g>
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "1px 0px 0px",
                      top: 54,
                      left: 9,
                      width: 75,
                      height: 25,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i2"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 2,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: "100%", height: "auto" }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i2"
                            data-vg-test-label="text-element-0"
                            style={{ width: "100%" }}
                          >
                            <div>
                              <div
                                id="draftEditor-3ee22676-0d09-46ca-acc8-59af1ae3a431"
                                className="styles__cleanCssRoot--SYmyP"
                                style={{ textAlign: "center" }}
                              >
                                <div className="DraftEditor-root">
                                  <div
                                    className="DraftEditor-editorContainer"
                                    style={{ position: "initial" }}
                                  >
                                    <div
                                      aria-describedby="placeholder-7o8r2"
                                      className="public-DraftEditor-content"
                                      contentEditable="false"
                                      spellCheck="true"
                                      style={{
                                        outline: "none",
                                        userSelect: "text",
                                        whiteSpace: "pre-wrap",
                                        overflowWrap: "break-word"
                                      }}
                                    >
                                      <div data-contents="true">
                                        <div
                                          className="draftjs-textalign-center"
                                          data-block="true"
                                          data-editor="7o8r2"
                                          data-offset-key="default-0-0"
                                          style={{
                                            fontFamily: '"Barlow Condensed"',
                                            fontSize: 17,
                                            color: "rgb(255, 255, 255)",
                                            lineHeight: "1.2"
                                          }}
                                        >
                                          <div
                                            data-offset-key="default-0-0"
                                            className="public-DraftStyleDefault-block public-DraftStyleDefault-ltr"
                                          >
                                            <span
                                              data-offset-key="default-0-0"
                                              style={{
                                                fontFamily:
                                                  '"Barlow Condensed"',
                                                fontSize: 17,
                                                color: "rgb(255, 255, 255)",
                                                lineHeight: "1.2",
                                                fontWeight: "normal",
                                                fontStyle: "normal"
                                              }}
                                            >
                                              <span data-text="true">
                                                MY YUM
                                              </span>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="styles__wrappedComponent--26Cp_ ignore-jqueryui-selectable vg-canvas-event-wrapper-component"
              data-key="3ee22676-0d09-46ca-acc8-59af1ae3a431/node_Zm1yW8jzcp"
              style={{ pointerEvents: "auto" }}
            >
              <div
                data-widgettype="Diagram"
                data-id="node_Zm1yW8jzcp"
                data-vg-test-label="smart-node-15"
                style={{
                  left: "161.825px",
                  top: "425.875px",
                  width: "93.2969px",
                  height: "auto",
                  background: "rgb(81, 122, 128)",
                  position: "relative",
                  borderRadius: 13,
                  transform: "none",
                  transformOrigin: "center center"
                }}
              >
                <div
                  className="styles__nodeBordersContainer--1j-sR"
                  style={{
                    borderRadius: 16,
                    borderWidth: 3,
                    borderStyle: "solid",
                    borderColor: "rgb(104, 42, 141)",
                    margin: "-3px 0px 0px -3px"
                  }}
                />
                <div
                  className="react-grid-layout styles__root--37lJs"
                  style={{ height: "88.7775px" }}
                >
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "0px 0px 1px",
                      top: 9,
                      left: 9,
                      width: 75,
                      height: 45,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i1"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 6,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: 63, height: 32 }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i1"
                            data-vg-test-label="icon-element-0"
                          >
                            <div
                              className="styles__shape--29_P3"
                              style={{ width: 63, height: 32 }}
                            >
                              <svg
                                width="100%"
                                height="100%"
                                fill="rgb(255, 255, 255)"
                                xmlns="http://www.w3.org/2000/svg"
                                pointerEvents="bounding-box"
                                preserveAspectRatio="xMidYMin"
                                style={{
                                  position: "unset",
                                  pointerEvents: "none"
                                }}
                                viewBox="1 0.0898 24.0586 25.8789"
                              >
                                <g>
                                  <path
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{
                                      textIndent: 0,
                                      textAlign: "start",
                                      lineHeight: "normal",
                                      textTransform: "none",
                                      blockProgression: "tb",
                                      InkscapeFontSpecification:
                                        "Bitstream Vera Sans"
                                    }}
                                    d="M 20.84375 0.09375 C 20.63125 0.06875 20.3875 0.2 20.1875 0.5 L 18.21875 3.1875 C 16.648399 2.4393084 14.889565 2 13 2 C 6.3896552 2 1 7.3896552 1 14 L 1 14.0625 A 1.50015 1.50015 0 0 0 1 14.1875 L 1.0625 15.15625 L 1.0625 15.3125 L 1.21875 16.21875 L 1.9375 17.28125 L 3.21875 17.40625 L 4.125 16.46875 L 4.1875 15.75 L 4.0625 15 L 4 14.09375 A 1.50015 1.50015 0 0 0 4 14 L 4 13.9375 C 4.0331912 8.9767822 8.031112 5 13 5 C 14.234955 5 15.373423 5.2111266 16.40625 5.625 L 14.8125 7.8125 C 14.4125 8.4125 14.4 8.80625 15 8.90625 L 24.1875 10.1875 C 24.8875 10.2875 25.2 9.8875 25 9.1875 L 21.40625 0.59375 C 21.25625 0.29375 21.05625 0.11875 20.84375 0.09375 z M 23.21875 15.4375 L 22 15.90625 L 21.65625 16.5 L 21.5 17 L 21.28125 17.59375 L 21.25 17.59375 L 21 18.125 L 20.96875 19.40625 L 21.9375 20.25 L 23.21875 20 L 23.6875 19.46875 L 23.9375 18.96875 L 24 18.84375 L 24.34375 17.96875 L 24.375 17.84375 L 24.53125 17.375 L 24.3125 16.09375 L 23.21875 15.4375 z M 4.8125 19 L 3.625 19.5 L 3.28125 20.75 L 3.5625 21.375 L 3.6875 21.5625 L 3.78125 21.6875 L 4.46875 22.4375 L 4.5625 22.53125 L 5.125 23.03125 L 6.375 23.40625 L 7.4375 22.6875 L 7.53125 21.40625 L 7.15625 20.8125 L 6.6875 20.40625 L 6.625 20.34375 L 6.59375 20.3125 L 6.09375 19.78125 L 6.03125 19.6875 L 6 19.65625 L 5.96875 19.59375 L 4.8125 19 z M 18.9375 21.0625 L 18.28125 21.28125 L 17.6875 21.6875 L 17.59375 21.75 L 17 22.0625 L 16.96875 22.09375 L 16.875 22.125 L 16.78125 22.15625 L 15.9375 23.125 L 16.15625 24.40625 L 17.28125 25.03125 L 17.96875 24.90625 L 18.1875 24.8125 L 18.3125 24.75 L 19.125 24.3125 L 19.25 24.25 L 19.9375 23.78125 L 20.59375 22.6875 L 20.15625 21.46875 L 18.9375 21.0625 z M 10.90625 22.75 L 9.65625 23 L 9.03125 24.125 L 9.53125 25.3125 L 10.15625 25.65625 L 10.5 25.75 L 10.65625 25.78125 L 11.6875 25.9375 L 11.84375 25.9375 L 12.4375 25.96875 L 13.625 25.46875 L 14 24.25 L 13.25 23.1875 L 12.59375 22.96875 L 12 22.9375 L 11.25 22.84375 L 11.15625 22.8125 L 11.125 22.8125 L 10.90625 22.75 z"
                                    color="#000"
                                    overflow="visible"
                                    enableBackground="accumulate"
                                    fontFamily="Bitstream Vera Sans"
                                  />
                                </g>
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "1px 0px 0px",
                      top: 54,
                      left: 9,
                      width: 75,
                      height: 25,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i2"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 2,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: "100%", height: "auto" }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i2"
                            data-vg-test-label="text-element-0"
                            style={{ width: "100%" }}
                          >
                            <div>
                              <div
                                id="draftEditor-3ee22676-0d09-46ca-acc8-59af1ae3a431"
                                className="styles__cleanCssRoot--SYmyP"
                                style={{ textAlign: "center" }}
                              >
                                <div className="DraftEditor-root">
                                  <div
                                    className="DraftEditor-editorContainer"
                                    style={{ position: "initial" }}
                                  >
                                    <div
                                      aria-describedby="placeholder-1mqmm"
                                      className="public-DraftEditor-content"
                                      contentEditable="false"
                                      spellCheck="true"
                                      style={{
                                        outline: "none",
                                        userSelect: "text",
                                        whiteSpace: "pre-wrap",
                                        overflowWrap: "break-word"
                                      }}
                                    >
                                      <div data-contents="true">
                                        <div
                                          className="draftjs-textalign-center"
                                          data-block="true"
                                          data-editor="1mqmm"
                                          data-offset-key="default-0-0"
                                          style={{
                                            fontFamily: '"Barlow Condensed"',
                                            fontSize: 17,
                                            color: "rgb(255, 255, 255)",
                                            lineHeight: "1.2"
                                          }}
                                        >
                                          <div
                                            data-offset-key="default-0-0"
                                            className="public-DraftStyleDefault-block public-DraftStyleDefault-ltr"
                                          >
                                            <span
                                              data-offset-key="default-0-0"
                                              style={{
                                                fontFamily:
                                                  '"Barlow Condensed"',
                                                fontSize: 17,
                                                color: "rgb(255, 255, 255)",
                                                lineHeight: "1.2",
                                                fontWeight: "normal",
                                                fontStyle: "normal"
                                              }}
                                            >
                                              <span data-text="true">
                                                GSS
                                              </span>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="styles__wrappedComponent--26Cp_ ignore-jqueryui-selectable vg-canvas-event-wrapper-component"
              data-key="3ee22676-0d09-46ca-acc8-59af1ae3a431/node_3o9YDJ_myX"
              style={{ pointerEvents: "auto" }}
            >
              <div
                data-widgettype="Diagram"
                data-id="node_3o9YDJ_myX"
                data-vg-test-label="smart-node-16"
                style={{
                  left: "646.005px",
                  top: "425.004px",
                  width: "93.2969px",
                  height: "auto",
                  background: "rgb(81, 122, 128)",
                  position: "relative",
                  borderRadius: 13,
                  transform: "none",
                  transformOrigin: "center center"
                }}
              >
                <div
                  className="styles__nodeBordersContainer--1j-sR"
                  style={{
                    borderRadius: 16,
                    borderWidth: 3,
                    borderStyle: "solid",
                    borderColor: "rgb(207, 10, 43)",
                    margin: "-3px 0px 0px -3px"
                  }}
                />
                <div
                  className="react-grid-layout styles__root--37lJs"
                  style={{ height: "88.7775px" }}
                >
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "0px 0px 1px",
                      top: 9,
                      left: 9,
                      width: 75,
                      height: 45,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i1"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 6,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: 63, height: 32 }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i1"
                            data-vg-test-label="icon-element-0"
                          >
                            <div
                              className="styles__shape--29_P3"
                              style={{ width: 63, height: 32 }}
                            >
                              <svg
                                width="100%"
                                height="100%"
                                fill="rgb(255, 255, 255)"
                                xmlns="http://www.w3.org/2000/svg"
                                pointerEvents="bounding-box"
                                preserveAspectRatio="xMidYMin"
                                style={{
                                  position: "unset",
                                  pointerEvents: "none"
                                }}
                                viewBox="0 0 26 26"
                              >
                                <g>
                                  <path
                                    xmlns="http://www.w3.org/2000/svg"
                                    d="M 7 0 C 6.449 0 6 0.449 6 1 L 6 4 C 6 4.551 6.449 5 7 5 C 7.551 5 8 4.551 8 4 L 8 1 C 8 0.449 7.551 0 7 0 z M 19 0 C 18.449 0 18 0.449 18 1 L 18 4 C 18 4.551 18.449 5 19 5 C 19.551 5 20 4.551 20 4 L 20 1 C 20 0.449 19.551 0 19 0 z M 3 2 C 1.344 2 0 3.344 0 5 L 0 23 C 0 24.656 1.344 26 3 26 L 23 26 C 24.656 26 26 24.656 26 23 L 26 5 C 26 3.344 24.656 2 23 2 L 21 2 L 21 4 C 21 5.103 20.103 6 19 6 C 17.896 6 17 5.103 17 4 L 17 2 L 9 2 L 9 4 C 9 5.103 8.103 6 7 6 C 5.897 6 5 5.103 5 4 L 5 2 L 3 2 z M 2 9 L 24 9 L 24 23 C 24 23.551 23.551 24 23 24 L 3 24 C 2.449 24 2 23.551 2 23 L 2 9 z M 13 11 L 9 15 L 17 15 L 13 11 z M 9 18 L 13 22 L 17 18 L 9 18 z"
                                  />
                                </g>
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "1px 0px 0px",
                      top: 54,
                      left: 9,
                      width: 75,
                      height: 25,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i2"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgb(255, 255, 255)",
                          boxSizing: "border-box",
                          padding: 2,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: "100%", height: "auto" }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i2"
                            data-vg-test-label="text-element-0"
                            style={{ width: "100%" }}
                          >
                            <div>
                              <div
                                id="draftEditor-3ee22676-0d09-46ca-acc8-59af1ae3a431"
                                className="styles__cleanCssRoot--SYmyP"
                                style={{ textAlign: "center" }}
                              >
                                <div className="DraftEditor-root">
                                  <div
                                    className="DraftEditor-editorContainer"
                                    style={{ position: "initial" }}
                                  >
                                    <div
                                      aria-describedby="placeholder-ee3aj"
                                      className="public-DraftEditor-content"
                                      contentEditable="false"
                                      spellCheck="true"
                                      style={{
                                        outline: "none",
                                        userSelect: "text",
                                        whiteSpace: "pre-wrap",
                                        overflowWrap: "break-word"
                                      }}
                                    >
                                      <div data-contents="true">
                                        <div
                                          className="draftjs-textalign-center"
                                          data-block="true"
                                          data-editor="ee3aj"
                                          data-offset-key="default-0-0"
                                          style={{
                                            fontFamily: '"Barlow Condensed"',
                                            fontSize: 17,
                                            color: "rgb(255, 255, 255)",
                                            lineHeight: "1.2"
                                          }}
                                        >
                                          <div
                                            data-offset-key="default-0-0"
                                            className="public-DraftStyleDefault-block public-DraftStyleDefault-ltr"
                                          >
                                            <span
                                              data-offset-key="default-0-0"
                                              style={{
                                                fontFamily:
                                                  '"Barlow Condensed"',
                                                fontSize: 17,
                                                color: "rgb(255, 255, 255)",
                                                lineHeight: "1.2",
                                                fontWeight: "normal",
                                                fontStyle: "normal"
                                              }}
                                            >
                                              <span data-text="true">
                                                GSS
                                              </span>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="styles__wrappedComponent--26Cp_ ignore-jqueryui-selectable vg-canvas-event-wrapper-component"
              data-key="3ee22676-0d09-46ca-acc8-59af1ae3a431/node_UdsDBQ1Oy1"
              style={{ pointerEvents: "auto" }}
            >
              <div
                data-widgettype="Diagram"
                data-id="node_UdsDBQ1Oy1"
                data-vg-test-label="smart-node-17"
                style={{
                  left: "730.517px",
                  top: "575.518px",
                  width: "81.875px",
                  height: "auto",
                  background: "rgb(81, 122, 128)",
                  position: "relative",
                  borderRadius: 13,
                  transform: "none",
                  transformOrigin: "center center"
                }}
              >
                <div
                  className="styles__nodeBordersContainer--1j-sR"
                  style={{
                    borderRadius: 16,
                    borderWidth: 3,
                    borderStyle: "solid",
                    borderColor: "rgb(245, 130, 31)",
                    margin: "-3px 0px 0px -3px"
                  }}
                />
                <div
                  className="react-grid-layout styles__root--37lJs"
                  style={{ height: "78.8291px" }}
                >
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "0px 0px 1px",
                      top: 8,
                      left: 8,
                      width: 66,
                      height: 40,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i1"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 5,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: 56, height: 29 }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i1"
                            data-vg-test-label="icon-element-0"
                          >
                            <div
                              className="styles__shape--29_P3"
                              style={{ width: 56, height: 29 }}
                            >
                              <svg
                                width="100%"
                                height="100%"
                                fill="rgb(255, 255, 255)"
                                xmlns="http://www.w3.org/2000/svg"
                                pointerEvents="bounding-box"
                                preserveAspectRatio="xMidYMin"
                                style={{
                                  position: "unset",
                                  pointerEvents: "none"
                                }}
                                viewBox="2 2 20 20"
                              >
                                <g>
                                  <path
                                    xmlns="http://www.w3.org/2000/svg"
                                    d="M 12 2 C 6.5 2 2 6.5 2 12 C 2 17.5 6.5 22 12 22 C 17.5 22 22 17.5 22 12 C 22 6.5 17.5 2 12 2 z M 12 4 C 16.4 4 20 7.6 20 12 C 20 16.4 16.4 20 12 20 C 7.6 20 4 16.4 4 12 C 4 7.6 7.6 4 12 4 z M 11.90625 7 C 8.60625 7 9 10 9 10 L 11 10 C 11 8.6 11.7 8.5 12 8.5 C 12.8 8.5 13 9.4125 13 9.8125 C 13 11.9125 11 11.4 11 14 L 13 14 C 13 12.3 15 12.2125 15 9.8125 C 15 8.9125 14.50625 7 11.90625 7 z M 11 15 L 11 17 L 13 17 L 13 15 L 11 15 z"
                                  />
                                </g>
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "1px 0px 0px",
                      top: 48,
                      left: 8,
                      width: 66,
                      height: 23,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i2"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 2,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: "100%", height: "auto" }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i2"
                            data-vg-test-label="text-element-0"
                            style={{ width: "100%" }}
                          >
                            <div>
                              <div
                                id="draftEditor-3ee22676-0d09-46ca-acc8-59af1ae3a431"
                                className="styles__cleanCssRoot--SYmyP"
                                style={{ textAlign: "center" }}
                              >
                                <div className="DraftEditor-root">
                                  <div
                                    className="DraftEditor-editorContainer"
                                    style={{ position: "initial" }}
                                  >
                                    <div
                                      aria-describedby="placeholder-7rdsq"
                                      className="public-DraftEditor-content"
                                      contentEditable="false"
                                      spellCheck="true"
                                      style={{
                                        outline: "none",
                                        userSelect: "text",
                                        whiteSpace: "pre-wrap",
                                        overflowWrap: "break-word"
                                      }}
                                    >
                                      <div data-contents="true">
                                        <div
                                          className="draftjs-textalign-center"
                                          data-block="true"
                                          data-editor="7rdsq"
                                          data-offset-key="default-0-0"
                                          style={{
                                            fontFamily: '"Barlow Condensed"',
                                            fontSize: 15,
                                            color: "rgb(255, 255, 255)",
                                            lineHeight: "1.2"
                                          }}
                                        >
                                          <div
                                            data-offset-key="default-0-0"
                                            className="public-DraftStyleDefault-block public-DraftStyleDefault-ltr"
                                          >
                                            <span
                                              data-offset-key="default-0-0"
                                              style={{
                                                fontFamily:
                                                  '"Barlow Condensed"',
                                                fontSize: 15,
                                                color: "rgb(255, 255, 255)",
                                                lineHeight: "1.2",
                                                fontWeight: "normal",
                                                fontStyle: "normal"
                                              }}
                                            >
                                              <span data-text="true">
                                                Medellia
                                              </span>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="styles__wrappedComponent--26Cp_ ignore-jqueryui-selectable vg-canvas-event-wrapper-component"
              data-key="3ee22676-0d09-46ca-acc8-59af1ae3a431/node_yh_G2OrB-g"
              style={{ pointerEvents: "auto" }}
            >
              <div
                data-widgettype="Diagram"
                data-id="node_yh_G2OrB-g"
                data-vg-test-label="smart-node-18"
                style={{
                  left: "287.39px",
                  top: "424.815px",
                  width: "93.2969px",
                  height: "auto",
                  background: "rgb(81, 122, 128)",
                  position: "relative",
                  borderRadius: 13,
                  transform: "none",
                  transformOrigin: "center center"
                }}
              >
                <div
                  className="styles__nodeBordersContainer--1j-sR"
                  style={{
                    borderRadius: 16,
                    borderWidth: 3,
                    borderStyle: "solid",
                    borderColor: "rgb(104, 42, 141)",
                    margin: "-3px 0px 0px -3px"
                  }}
                />
                <div
                  className="react-grid-layout styles__root--37lJs"
                  style={{ height: "88.7775px" }}
                >
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "0px 0px 1px",
                      top: 9,
                      left: 9,
                      width: 75,
                      height: 45,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i1"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 6,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: 63, height: 32 }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i1"
                            data-vg-test-label="icon-element-0"
                          >
                            <div
                              className="styles__shape--29_P3"
                              style={{ width: 63, height: 32 }}
                            >
                              <svg
                                width="100%"
                                height="100%"
                                fill="rgb(255, 255, 255)"
                                xmlns="http://www.w3.org/2000/svg"
                                pointerEvents="bounding-box"
                                preserveAspectRatio="xMidYMin"
                                style={{
                                  position: "unset",
                                  pointerEvents: "none"
                                }}
                                viewBox="1 0.0898 24.0586 25.8789"
                              >
                                <g>
                                  <path
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{
                                      textIndent: 0,
                                      textAlign: "start",
                                      lineHeight: "normal",
                                      textTransform: "none",
                                      blockProgression: "tb",
                                      InkscapeFontSpecification:
                                        "Bitstream Vera Sans"
                                    }}
                                    d="M 20.84375 0.09375 C 20.63125 0.06875 20.3875 0.2 20.1875 0.5 L 18.21875 3.1875 C 16.648399 2.4393084 14.889565 2 13 2 C 6.3896552 2 1 7.3896552 1 14 L 1 14.0625 A 1.50015 1.50015 0 0 0 1 14.1875 L 1.0625 15.15625 L 1.0625 15.3125 L 1.21875 16.21875 L 1.9375 17.28125 L 3.21875 17.40625 L 4.125 16.46875 L 4.1875 15.75 L 4.0625 15 L 4 14.09375 A 1.50015 1.50015 0 0 0 4 14 L 4 13.9375 C 4.0331912 8.9767822 8.031112 5 13 5 C 14.234955 5 15.373423 5.2111266 16.40625 5.625 L 14.8125 7.8125 C 14.4125 8.4125 14.4 8.80625 15 8.90625 L 24.1875 10.1875 C 24.8875 10.2875 25.2 9.8875 25 9.1875 L 21.40625 0.59375 C 21.25625 0.29375 21.05625 0.11875 20.84375 0.09375 z M 23.21875 15.4375 L 22 15.90625 L 21.65625 16.5 L 21.5 17 L 21.28125 17.59375 L 21.25 17.59375 L 21 18.125 L 20.96875 19.40625 L 21.9375 20.25 L 23.21875 20 L 23.6875 19.46875 L 23.9375 18.96875 L 24 18.84375 L 24.34375 17.96875 L 24.375 17.84375 L 24.53125 17.375 L 24.3125 16.09375 L 23.21875 15.4375 z M 4.8125 19 L 3.625 19.5 L 3.28125 20.75 L 3.5625 21.375 L 3.6875 21.5625 L 3.78125 21.6875 L 4.46875 22.4375 L 4.5625 22.53125 L 5.125 23.03125 L 6.375 23.40625 L 7.4375 22.6875 L 7.53125 21.40625 L 7.15625 20.8125 L 6.6875 20.40625 L 6.625 20.34375 L 6.59375 20.3125 L 6.09375 19.78125 L 6.03125 19.6875 L 6 19.65625 L 5.96875 19.59375 L 4.8125 19 z M 18.9375 21.0625 L 18.28125 21.28125 L 17.6875 21.6875 L 17.59375 21.75 L 17 22.0625 L 16.96875 22.09375 L 16.875 22.125 L 16.78125 22.15625 L 15.9375 23.125 L 16.15625 24.40625 L 17.28125 25.03125 L 17.96875 24.90625 L 18.1875 24.8125 L 18.3125 24.75 L 19.125 24.3125 L 19.25 24.25 L 19.9375 23.78125 L 20.59375 22.6875 L 20.15625 21.46875 L 18.9375 21.0625 z M 10.90625 22.75 L 9.65625 23 L 9.03125 24.125 L 9.53125 25.3125 L 10.15625 25.65625 L 10.5 25.75 L 10.65625 25.78125 L 11.6875 25.9375 L 11.84375 25.9375 L 12.4375 25.96875 L 13.625 25.46875 L 14 24.25 L 13.25 23.1875 L 12.59375 22.96875 L 12 22.9375 L 11.25 22.84375 L 11.15625 22.8125 L 11.125 22.8125 L 10.90625 22.75 z"
                                    color="#000"
                                    overflow="visible"
                                    enableBackground="accumulate"
                                    fontFamily="Bitstream Vera Sans"
                                  />
                                </g>
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "1px 0px 0px",
                      top: 54,
                      left: 9,
                      width: 75,
                      height: 25,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i2"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 2,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: "100%", height: "auto" }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i2"
                            data-vg-test-label="text-element-0"
                            style={{ width: "100%" }}
                          >
                            <div>
                              <div
                                id="draftEditor-3ee22676-0d09-46ca-acc8-59af1ae3a431"
                                className="styles__cleanCssRoot--SYmyP"
                                style={{ textAlign: "center" }}
                              >
                                <div className="DraftEditor-root">
                                  <div
                                    className="DraftEditor-editorContainer"
                                    style={{ position: "initial" }}
                                  >
                                    <div
                                      aria-describedby="placeholder-eou89"
                                      className="public-DraftEditor-content"
                                      contentEditable="false"
                                      spellCheck="true"
                                      style={{
                                        outline: "none",
                                        userSelect: "text",
                                        whiteSpace: "pre-wrap",
                                        overflowWrap: "break-word"
                                      }}
                                    >
                                      <div data-contents="true">
                                        <div
                                          className="draftjs-textalign-center"
                                          data-block="true"
                                          data-editor="eou89"
                                          data-offset-key="default-0-0"
                                          style={{
                                            fontFamily: '"Barlow Condensed"',
                                            fontSize: 17,
                                            color: "rgb(255, 255, 255)",
                                            lineHeight: "1.2"
                                          }}
                                        >
                                          <div
                                            data-offset-key="default-0-0"
                                            className="public-DraftStyleDefault-block public-DraftStyleDefault-ltr"
                                          >
                                            <span
                                              data-offset-key="default-0-0"
                                              style={{
                                                fontFamily:
                                                  '"Barlow Condensed"',
                                                fontSize: 17,
                                                color: "rgb(255, 255, 255)",
                                                lineHeight: "1.2",
                                                fontWeight: "normal",
                                                fontStyle: "normal"
                                              }}
                                            >
                                              <span data-text="true">
                                                McLain
                                              </span>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="styles__wrappedComponent--26Cp_ ignore-jqueryui-selectable vg-canvas-event-wrapper-component"
              data-key="3ee22676-0d09-46ca-acc8-59af1ae3a431/node_WU4OP7VhSC"
              style={{ pointerEvents: "auto" }}
            >
              <div
                data-widgettype="Diagram"
                data-id="node_WU4OP7VhSC"
                data-vg-test-label="smart-node-19"
                style={{
                  left: "352.718px",
                  top: "328.002px",
                  width: "93.2969px",
                  height: "auto",
                  background: "rgb(81, 122, 128)",
                  position: "relative",
                  borderRadius: 13,
                  transform: "none",
                  transformOrigin: "center center"
                }}
              >
                <div
                  className="styles__nodeBordersContainer--1j-sR"
                  style={{
                    borderRadius: 16,
                    borderWidth: 3,
                    borderStyle: "solid",
                    borderColor: "rgb(104, 42, 141)",
                    margin: "-3px 0px 0px -3px"
                  }}
                />
                <div
                  className="react-grid-layout styles__root--37lJs"
                  style={{ height: "88.7775px" }}
                >
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "0px 0px 1px",
                      top: 9,
                      left: 9,
                      width: 75,
                      height: 45,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i1"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 6,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: 63, height: 32 }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i1"
                            data-vg-test-label="icon-element-0"
                          >
                            <div
                              className="styles__shape--29_P3"
                              style={{ width: 63, height: 32 }}
                            >
                              <svg
                                width="100%"
                                height="100%"
                                fill="rgb(255, 255, 255)"
                                xmlns="http://www.w3.org/2000/svg"
                                pointerEvents="bounding-box"
                                preserveAspectRatio="xMidYMin"
                                style={{
                                  position: "unset",
                                  pointerEvents: "none"
                                }}
                                viewBox="1 0.0898 24.0586 25.8789"
                              >
                                <g>
                                  <path
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{
                                      textIndent: 0,
                                      textAlign: "start",
                                      lineHeight: "normal",
                                      textTransform: "none",
                                      blockProgression: "tb",
                                      InkscapeFontSpecification:
                                        "Bitstream Vera Sans"
                                    }}
                                    d="M 20.84375 0.09375 C 20.63125 0.06875 20.3875 0.2 20.1875 0.5 L 18.21875 3.1875 C 16.648399 2.4393084 14.889565 2 13 2 C 6.3896552 2 1 7.3896552 1 14 L 1 14.0625 A 1.50015 1.50015 0 0 0 1 14.1875 L 1.0625 15.15625 L 1.0625 15.3125 L 1.21875 16.21875 L 1.9375 17.28125 L 3.21875 17.40625 L 4.125 16.46875 L 4.1875 15.75 L 4.0625 15 L 4 14.09375 A 1.50015 1.50015 0 0 0 4 14 L 4 13.9375 C 4.0331912 8.9767822 8.031112 5 13 5 C 14.234955 5 15.373423 5.2111266 16.40625 5.625 L 14.8125 7.8125 C 14.4125 8.4125 14.4 8.80625 15 8.90625 L 24.1875 10.1875 C 24.8875 10.2875 25.2 9.8875 25 9.1875 L 21.40625 0.59375 C 21.25625 0.29375 21.05625 0.11875 20.84375 0.09375 z M 23.21875 15.4375 L 22 15.90625 L 21.65625 16.5 L 21.5 17 L 21.28125 17.59375 L 21.25 17.59375 L 21 18.125 L 20.96875 19.40625 L 21.9375 20.25 L 23.21875 20 L 23.6875 19.46875 L 23.9375 18.96875 L 24 18.84375 L 24.34375 17.96875 L 24.375 17.84375 L 24.53125 17.375 L 24.3125 16.09375 L 23.21875 15.4375 z M 4.8125 19 L 3.625 19.5 L 3.28125 20.75 L 3.5625 21.375 L 3.6875 21.5625 L 3.78125 21.6875 L 4.46875 22.4375 L 4.5625 22.53125 L 5.125 23.03125 L 6.375 23.40625 L 7.4375 22.6875 L 7.53125 21.40625 L 7.15625 20.8125 L 6.6875 20.40625 L 6.625 20.34375 L 6.59375 20.3125 L 6.09375 19.78125 L 6.03125 19.6875 L 6 19.65625 L 5.96875 19.59375 L 4.8125 19 z M 18.9375 21.0625 L 18.28125 21.28125 L 17.6875 21.6875 L 17.59375 21.75 L 17 22.0625 L 16.96875 22.09375 L 16.875 22.125 L 16.78125 22.15625 L 15.9375 23.125 L 16.15625 24.40625 L 17.28125 25.03125 L 17.96875 24.90625 L 18.1875 24.8125 L 18.3125 24.75 L 19.125 24.3125 L 19.25 24.25 L 19.9375 23.78125 L 20.59375 22.6875 L 20.15625 21.46875 L 18.9375 21.0625 z M 10.90625 22.75 L 9.65625 23 L 9.03125 24.125 L 9.53125 25.3125 L 10.15625 25.65625 L 10.5 25.75 L 10.65625 25.78125 L 11.6875 25.9375 L 11.84375 25.9375 L 12.4375 25.96875 L 13.625 25.46875 L 14 24.25 L 13.25 23.1875 L 12.59375 22.96875 L 12 22.9375 L 11.25 22.84375 L 11.15625 22.8125 L 11.125 22.8125 L 10.90625 22.75 z"
                                    color="#000"
                                    overflow="visible"
                                    enableBackground="accumulate"
                                    fontFamily="Bitstream Vera Sans"
                                  />
                                </g>
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "1px 0px 0px",
                      top: 54,
                      left: 9,
                      width: 75,
                      height: 25,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i2"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 2,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: "100%", height: "auto" }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i2"
                            data-vg-test-label="text-element-0"
                            style={{ width: "100%" }}
                          >
                            <div>
                              <div
                                id="draftEditor-3ee22676-0d09-46ca-acc8-59af1ae3a431"
                                className="styles__cleanCssRoot--SYmyP"
                                style={{ textAlign: "center" }}
                              >
                                <div className="DraftEditor-root">
                                  <div
                                    className="DraftEditor-editorContainer"
                                    style={{ position: "initial" }}
                                  >
                                    <div
                                      aria-describedby="placeholder-2n03j"
                                      className="public-DraftEditor-content"
                                      contentEditable="false"
                                      spellCheck="true"
                                      style={{
                                        outline: "none",
                                        userSelect: "text",
                                        whiteSpace: "pre-wrap",
                                        overflowWrap: "break-word"
                                      }}
                                    >
                                      <div data-contents="true">
                                        <div
                                          className="draftjs-textalign-center"
                                          data-block="true"
                                          data-editor="2n03j"
                                          data-offset-key="default-0-0"
                                          style={{
                                            fontFamily: '"Barlow Condensed"',
                                            fontSize: 17,
                                            color: "rgb(255, 255, 255)",
                                            lineHeight: "1.2"
                                          }}
                                        >
                                          <div
                                            data-offset-key="default-0-0"
                                            className="public-DraftStyleDefault-block public-DraftStyleDefault-ltr"
                                          >
                                            <span
                                              data-offset-key="default-0-0"
                                              style={{
                                                fontFamily:
                                                  '"Barlow Condensed"',
                                                fontSize: 17,
                                                color: "rgb(255, 255, 255)",
                                                lineHeight: "1.2",
                                                fontWeight: "normal",
                                                fontStyle: "normal"
                                              }}
                                            >
                                              <span data-text="true">
                                                erestaurant
                                              </span>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="styles__wrappedComponent--26Cp_ ignore-jqueryui-selectable vg-canvas-event-wrapper-component"
              data-key="3ee22676-0d09-46ca-acc8-59af1ae3a431/node_TzP4nGuP8A"
              style={{ pointerEvents: "auto" }}
            >
              <div
                data-widgettype="Diagram"
                data-id="node_TzP4nGuP8A"
                data-vg-test-label="smart-node-20"
                style={{
                  left: "766.007px",
                  top: "426.005px",
                  width: "93.2969px",
                  height: "auto",
                  background: "rgb(81, 122, 128)",
                  position: "relative",
                  borderRadius: 13,
                  transform: "none",
                  transformOrigin: "center center"
                }}
              >
                <div
                  className="styles__nodeBordersContainer--1j-sR"
                  style={{
                    borderRadius: 16,
                    borderWidth: 3,
                    borderStyle: "solid",
                    borderColor: "rgb(207, 10, 43)",
                    margin: "-3px 0px 0px -3px"
                  }}
                />
                <div
                  className="react-grid-layout styles__root--37lJs"
                  style={{ height: "88.7775px" }}
                >
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "0px 0px 1px",
                      top: 9,
                      left: 9,
                      width: 75,
                      height: 45,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i1"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 6,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: 63, height: 32 }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i1"
                            data-vg-test-label="icon-element-0"
                          >
                            <div
                              className="styles__shape--29_P3"
                              style={{ width: 63, height: 32 }}
                            >
                              <svg
                                width="100%"
                                height="100%"
                                fill="rgb(255, 255, 255)"
                                xmlns="http://www.w3.org/2000/svg"
                                pointerEvents="bounding-box"
                                preserveAspectRatio="xMidYMin"
                                style={{
                                  position: "unset",
                                  pointerEvents: "none"
                                }}
                                viewBox="0 0 26 26"
                              >
                                <g>
                                  <path
                                    xmlns="http://www.w3.org/2000/svg"
                                    d="M 7 0 C 6.449 0 6 0.449 6 1 L 6 4 C 6 4.551 6.449 5 7 5 C 7.551 5 8 4.551 8 4 L 8 1 C 8 0.449 7.551 0 7 0 z M 19 0 C 18.449 0 18 0.449 18 1 L 18 4 C 18 4.551 18.449 5 19 5 C 19.551 5 20 4.551 20 4 L 20 1 C 20 0.449 19.551 0 19 0 z M 3 2 C 1.344 2 0 3.344 0 5 L 0 23 C 0 24.656 1.344 26 3 26 L 23 26 C 24.656 26 26 24.656 26 23 L 26 5 C 26 3.344 24.656 2 23 2 L 21 2 L 21 4 C 21 5.103 20.103 6 19 6 C 17.896 6 17 5.103 17 4 L 17 2 L 9 2 L 9 4 C 9 5.103 8.103 6 7 6 C 5.897 6 5 5.103 5 4 L 5 2 L 3 2 z M 2 9 L 24 9 L 24 23 C 24 23.551 23.551 24 23 24 L 3 24 C 2.449 24 2 23.551 2 23 L 2 9 z M 13 11 L 9 15 L 17 15 L 13 11 z M 9 18 L 13 22 L 17 18 L 9 18 z"
                                  />
                                </g>
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "1px 0px 0px",
                      top: 54,
                      left: 9,
                      width: 75,
                      height: 25,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i2"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 2,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: "100%", height: "auto" }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i2"
                            data-vg-test-label="text-element-0"
                            style={{ width: "100%" }}
                          >
                            <div>
                              <div
                                id="draftEditor-3ee22676-0d09-46ca-acc8-59af1ae3a431"
                                className="styles__cleanCssRoot--SYmyP"
                                style={{ textAlign: "center" }}
                              >
                                <div className="DraftEditor-root">
                                  <div
                                    className="DraftEditor-editorContainer"
                                    style={{ position: "initial" }}
                                  >
                                    <div
                                      aria-describedby="placeholder-424lt"
                                      className="public-DraftEditor-content"
                                      contentEditable="false"
                                      spellCheck="true"
                                      style={{
                                        outline: "none",
                                        userSelect: "text",
                                        whiteSpace: "pre-wrap",
                                        overflowWrap: "break-word"
                                      }}
                                    >
                                      <div data-contents="true">
                                        <div
                                          className="draftjs-textalign-center"
                                          data-block="true"
                                          data-editor="424lt"
                                          data-offset-key="default-0-0"
                                          style={{
                                            fontFamily: '"Barlow Condensed"',
                                            fontSize: 17,
                                            color: "rgb(255, 255, 255)",
                                            lineHeight: "1.2"
                                          }}
                                        >
                                          <div
                                            data-offset-key="default-0-0"
                                            className="public-DraftStyleDefault-block public-DraftStyleDefault-ltr"
                                          >
                                            <span
                                              data-offset-key="default-0-0"
                                              style={{
                                                fontFamily:
                                                  '"Barlow Condensed"',
                                                fontSize: 17,
                                                color: "rgb(255, 255, 255)",
                                                lineHeight: "1.2",
                                                fontWeight: "normal",
                                                fontStyle: "normal"
                                              }}
                                            >
                                              <span data-text="true">
                                                GSS
                                              </span>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="styles__wrappedComponent--26Cp_ ignore-jqueryui-selectable vg-canvas-event-wrapper-component"
              data-key="3ee22676-0d09-46ca-acc8-59af1ae3a431/node_ylMpbLlK4X"
              style={{ pointerEvents: "auto" }}
            >
              <div
                data-widgettype="Diagram"
                data-id="node_ylMpbLlK4X"
                data-vg-test-label="smart-node-21"
                style={{
                  left: "896.618px",
                  top: "408.713px",
                  width: "93.2969px",
                  height: "auto",
                  background: "rgb(81, 122, 128)",
                  position: "relative",
                  borderRadius: 13,
                  transform: "none",
                  transformOrigin: "center center"
                }}
              >
                <div
                  className="styles__nodeBordersContainer--1j-sR"
                  style={{
                    borderRadius: 16,
                    borderWidth: 3,
                    borderStyle: "solid",
                    borderColor: "rgb(207, 10, 43)",
                    margin: "-3px 0px 0px -3px"
                  }}
                />
                <div
                  className="react-grid-layout styles__root--37lJs"
                  style={{ height: "88.7775px" }}
                >
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "0px 0px 1px",
                      top: 9,
                      left: 9,
                      width: 75,
                      height: 45,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i1"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 6,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: 63, height: 32 }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i1"
                            data-vg-test-label="icon-element-0"
                          >
                            <div
                              className="styles__shape--29_P3"
                              style={{ width: 63, height: 32 }}
                            >
                              <svg
                                width="100%"
                                height="100%"
                                fill="rgb(255, 255, 255)"
                                xmlns="http://www.w3.org/2000/svg"
                                pointerEvents="bounding-box"
                                preserveAspectRatio="xMidYMin"
                                style={{
                                  position: "unset",
                                  pointerEvents: "none"
                                }}
                                viewBox="0 0 26 26"
                              >
                                <g>
                                  <path
                                    xmlns="http://www.w3.org/2000/svg"
                                    d="M 7 0 C 6.449 0 6 0.449 6 1 L 6 4 C 6 4.551 6.449 5 7 5 C 7.551 5 8 4.551 8 4 L 8 1 C 8 0.449 7.551 0 7 0 z M 19 0 C 18.449 0 18 0.449 18 1 L 18 4 C 18 4.551 18.449 5 19 5 C 19.551 5 20 4.551 20 4 L 20 1 C 20 0.449 19.551 0 19 0 z M 3 2 C 1.344 2 0 3.344 0 5 L 0 23 C 0 24.656 1.344 26 3 26 L 23 26 C 24.656 26 26 24.656 26 23 L 26 5 C 26 3.344 24.656 2 23 2 L 21 2 L 21 4 C 21 5.103 20.103 6 19 6 C 17.896 6 17 5.103 17 4 L 17 2 L 9 2 L 9 4 C 9 5.103 8.103 6 7 6 C 5.897 6 5 5.103 5 4 L 5 2 L 3 2 z M 2 9 L 24 9 L 24 23 C 24 23.551 23.551 24 23 24 L 3 24 C 2.449 24 2 23.551 2 23 L 2 9 z M 13 11 L 9 15 L 17 15 L 13 11 z M 9 18 L 13 22 L 17 18 L 9 18 z"
                                  />
                                </g>
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "1px 0px 0px",
                      top: 54,
                      left: 9,
                      width: 75,
                      height: 25,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i2"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 2,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: "100%", height: "auto" }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i2"
                            data-vg-test-label="text-element-0"
                            style={{ width: "100%" }}
                          >
                            <div>
                              <div
                                id="draftEditor-3ee22676-0d09-46ca-acc8-59af1ae3a431"
                                className="styles__cleanCssRoot--SYmyP"
                                style={{ textAlign: "center" }}
                              >
                                <div className="DraftEditor-root">
                                  <div
                                    className="DraftEditor-editorContainer"
                                    style={{ position: "initial" }}
                                  >
                                    <div
                                      aria-describedby="placeholder-7r25o"
                                      className="public-DraftEditor-content"
                                      contentEditable="false"
                                      spellCheck="true"
                                      style={{
                                        outline: "none",
                                        userSelect: "text",
                                        whiteSpace: "pre-wrap",
                                        overflowWrap: "break-word"
                                      }}
                                    >
                                      <div data-contents="true">
                                        <div
                                          className="draftjs-textalign-center"
                                          data-block="true"
                                          data-editor="7r25o"
                                          data-offset-key="default-0-0"
                                          style={{
                                            fontFamily: '"Barlow Condensed"',
                                            fontSize: 17,
                                            color: "rgb(255, 255, 255)",
                                            lineHeight: "1.2"
                                          }}
                                        >
                                          <div
                                            data-offset-key="default-0-0"
                                            className="public-DraftStyleDefault-block public-DraftStyleDefault-ltr"
                                          >
                                            <span
                                              data-offset-key="default-0-0"
                                              style={{
                                                fontFamily:
                                                  '"Barlow Condensed"',
                                                fontSize: 17,
                                                color: "rgb(255, 255, 255)",
                                                lineHeight: "1.2",
                                                fontWeight: "normal",
                                                fontStyle: "normal"
                                              }}
                                            >
                                              <span data-text="true">
                                                GSS
                                              </span>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="styles__wrappedComponent--26Cp_ ignore-jqueryui-selectable vg-canvas-event-wrapper-component"
              data-key="3ee22676-0d09-46ca-acc8-59af1ae3a431/node_4V_-ndxRK-"
              style={{ pointerEvents: "auto" }}
            >
              <div
                data-widgettype="Diagram"
                data-id="node_4V_-ndxRK-"
                data-vg-test-label="smart-node-22"
                style={{
                  left: "912.004px",
                  top: "307.004px",
                  width: "93.2969px",
                  height: "auto",
                  background: "rgb(81, 122, 128)",
                  position: "relative",
                  borderRadius: 13,
                  transform: "none",
                  transformOrigin: "center center"
                }}
              >
                <div
                  className="styles__nodeBordersContainer--1j-sR"
                  style={{
                    borderRadius: 16,
                    borderWidth: 3,
                    borderStyle: "solid",
                    borderColor: "rgb(207, 10, 43)",
                    margin: "-3px 0px 0px -3px"
                  }}
                />
                <div
                  className="react-grid-layout styles__root--37lJs"
                  style={{ height: "44.5" }}
                >
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "0px 0px 1px",
                      top: 9,
                      left: 9,
                      width: 75,
                      height: 45,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i1"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 6,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: 63, height: 32 }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i1"
                            data-vg-test-label="icon-element-0"
                          >
                            <div
                              className="styles__shape--29_P3"
                              style={{ width: 63, height: 32 }}
                            >
                              <svg
                                width="100%"
                                height="100%"
                                fill="rgb(255, 255, 255)"
                                xmlns="http://www.w3.org/2000/svg"
                                pointerEvents="bounding-box"
                                preserveAspectRatio="xMidYMin"
                                style={{
                                  position: "unset",
                                  pointerEvents: "none"
                                }}
                                viewBox="0 0 26 26"
                              >
                                <g>
                                  <path
                                    xmlns="http://www.w3.org/2000/svg"
                                    d="M 7 0 C 6.449 0 6 0.449 6 1 L 6 4 C 6 4.551 6.449 5 7 5 C 7.551 5 8 4.551 8 4 L 8 1 C 8 0.449 7.551 0 7 0 z M 19 0 C 18.449 0 18 0.449 18 1 L 18 4 C 18 4.551 18.449 5 19 5 C 19.551 5 20 4.551 20 4 L 20 1 C 20 0.449 19.551 0 19 0 z M 3 2 C 1.344 2 0 3.344 0 5 L 0 23 C 0 24.656 1.344 26 3 26 L 23 26 C 24.656 26 26 24.656 26 23 L 26 5 C 26 3.344 24.656 2 23 2 L 21 2 L 21 4 C 21 5.103 20.103 6 19 6 C 17.896 6 17 5.103 17 4 L 17 2 L 9 2 L 9 4 C 9 5.103 8.103 6 7 6 C 5.897 6 5 5.103 5 4 L 5 2 L 3 2 z M 2 9 L 24 9 L 24 23 C 24 23.551 23.551 24 23 24 L 3 24 C 2.449 24 2 23.551 2 23 L 2 9 z M 13 11 L 9 15 L 17 15 L 13 11 z M 9 18 L 13 22 L 17 18 L 9 18 z"
                                  />
                                </g>
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="react-grid-item styles__gridCell--18AbD"
                    style={{
                      padding: "1px 0px 0px",
                      top: 54,
                      left: 9,
                      width: 75,
                      height: 25,
                      position: "absolute"
                    }}
                  >
                    <div
                      data-id="i2"
                      className="styles__gridCellWrapper--1AQTk"
                    >
                      <div
                        className="styles__gridCell--2JKCu"
                        style={{
                          background: "rgba(242, 242, 242, 0)",
                          boxSizing: "border-box",
                          padding: 2,
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          zIndex: 0,
                          borderRadius: 0
                        }}
                      >
                        <div
                          className="styles__gridCellContent--1P2Ff"
                          style={{ width: "100%", height: "auto" }}
                        >
                          <div
                            data-id={0}
                            data-cellid="i2"
                            data-vg-test-label="text-element-0"
                            style={{ width: "100%" }}
                          >
                            <div>
                              <div
                                id="draftEditor-3ee22676-0d09-46ca-acc8-59af1ae3a431"
                                className="styles__cleanCssRoot--SYmyP"
                                style={{ textAlign: "center" }}
                              >
                                <div className="DraftEditor-root">
                                  <div
                                    className="DraftEditor-editorContainer"
                                    style={{ position: "initial" }}
                                  >
                                    <div
                                      aria-describedby="placeholder-208ps"
                                      className="public-DraftEditor-content"
                                      contentEditable="false"
                                      spellCheck="true"
                                      style={{
                                        outline: "none",
                                        userSelect: "text",
                                        whiteSpace: "pre-wrap",
                                        overflowWrap: "break-word"
                                      }}
                                    >
                                      <div data-contents="true">
                                        <div
                                          className="draftjs-textalign-center"
                                          data-block="true"
                                          data-editor="208ps"
                                          data-offset-key="default-0-0"
                                          style={{
                                            fontFamily: '"Barlow Condensed"',
                                            fontSize: 17,
                                            color: "rgb(255, 255, 255)",
                                            lineHeight: "1.2"
                                          }}
                                        >
                                          <div
                                            data-offset-key="default-0-0"
                                            className="public-DraftStyleDefault-block public-DraftStyleDefault-ltr"
                                          >
                                            <span
                                              data-offset-key="default-0-0"
                                              style={{
                                                fontFamily:
                                                  '"Barlow Condensed"',
                                                fontSize: 17,
                                                color: "rgb(255, 255, 255)",
                                                lineHeight: "1.2",
                                                fontWeight: "normal",
                                                fontStyle: "normal"
                                              }}
                                            >
                                              <span data-text="true">
                                                GSS
                                              </span>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="styles__cellBordersContainer--1CNfQ"
                          style={{
                            transform: "translateX(0px)",
                            borderRadius: 0
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="page_number"
        style={{ display: "none", color: "rgb(255, 255, 255)" }}
      >
        1
      </div>
      <div id="pages_container">
        <div
          className="vg-page"
          data-page-index={0}
          style={{ height: 816, width: 1056 }}
        />
        <div className="vg-page-break" data-page-index={0}>
          <span className="vg-page-number-before">1</span>
          <span className="vg-page-number-before right-number">1</span>
          <span className="vg-page-number-after">2</span>
          <span className="vg-page-number-after right-number">2</span>
        </div>
      </div>
      </div>
      <div id="MultipageOptions">
      <div id="styles__root___QQGuG" className=" ">
        <div>
          <a href="/infographics" data-vg-test-label="infographics-link">
            <img src="/media/v2_img/logo_white.svg" alt="Venngage" />
          </a>
        </div>
        <div>
          <div id="styles__pageNavigation___31UNt" className="">
            <button
              id="styles__previousPage___2I_m3"
              data-vg-test-label="previous-page-button"
              className="styles__disabled___3z5u5"
            >
              <div>
                <div id="styles__arrow___1Et2W">
                  <svg
                    width={8}
                    height={14}
                    viewBox="0 0 8 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 13L1 7L7 1"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </button>
            <div
              id="styles__pageInput___DVv30"
              data-vg-test-label="page-indicator"
            >
              1/1
            </div>
            <button
              id="styles__nextPage___aW19o"
              data-vg-test-label="next-page-button"
              className="styles__disabled___3z5u5"
            >
              <div>
                <div id="styles__arrow___1Et2W">
                  <svg
                    width={8}
                    height={14}
                    viewBox="0 0 8 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ transform: "rotate(180deg)" }}
                  >
                    <path
                      d="M7 13L1 7L7 1"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </button>
          </div>
        </div>
        <div>
          <div id="styles__otherOptions___zxnvu">
            <div
              id="styles__fullScreenOption___35z7E"
              data-vg-test-label="fullscreen-on-button"
              className="styles__optionEnabled___1wdT2 styles__darkButton___E-ivE"
            >
              <div style={{ width: 24, height: 24 }}>
                <svg
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16 4H20V8"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14 10L20 4"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8 20H4V16"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M4 20L10 14"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M16 20H20V16"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14 14L20 20"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8 4H4V8"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M4 4L10 10"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
            <div
              id="styles__accountButtonContainer___32--6"
              className="dropdown dropup"
            >
              <button
                type="button"
                id="styles__accountDropdownButton___1TBm1"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                data-vg-test-label="account-button"
              >
                <div>
                  <div id="styles__accountButton___2noKO">VP</div>
                </div>
              </button>
              <ul
                className="dropdown-menu"
                id="styles__dropdownMenu___3bb6d"
                aria-labelledby="styles__accountDropdownButton___1TBm1"
                data-vg-test-label="account-menu"
              >
                <div
                  className="tooltip-arrow"
                  id="styles__tooltipArrow___1vSlX"
                />
                <li>
                  <a
                    href="/account/profile"
                    data-vg-test-label="my-account-link"
                  >
                    My Account
                  </a>
                </li>
                <li>
                  <a
                    href="/logout?return_to=/login"
                    data-vg-test-label="logout-link"
                  >
                    Sign Out
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      </div>
      </div>

      </div>
      <link
      rel="stylesheet"
      href="https://cdn.venngage.com/23.09.0/3821d0b79d7a886bccfd7b858451cb92a6e7754c/infograph/core/venngage.css?v=23.09.0"
      />
      <link rel="preconnect" href="https://fonts.gstatic.com" />
      {/* Load latin fonts */}
      <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css?family=Abel:400|Abril+Fatface:400|Aldrich:400|Alegreya:400,700,400i,700i|Alfa+Slab+One:400|Allerta+Stencil:400|Amaranth:400,700,400i,700i|Anton:400|Archivo+Black:400|Archivo+Narrow:400,700,400i,700i|Arimo:400,700,400i,700i|Arvo:400,700,400i,700i|Asap:400|Averia+Libre:400,700,400i,700i|Averia+Sans+Libre:400,700,400i,700i|Averia+Serif+Libre:400,700,400i,700i|Bangers:400|Berkshire+Swash:400|Cabin:400,700,400i,700i|Chewy:400|Cinzel:400,700|Codystar:400|Contrail+One:400|Coustard:400|Didact+Gothic:400|Dosis:400,700|EB+Garamond:400|Economica:400,700,400i,700i|Expletus+Sans:400,700,400i,700i|Fredericka+the+Great:400|Fredoka+One:400|Graduate:400|Grand+Hotel:400|Great+Vibes:400|Josefin+Sans:400,700,400i,700i|Josefin+Slab:400,700,400i,700i|Julius+Sans+One:400|Karla:400,700,400i,700i|Knewave:400|Lato:400,700,400i,700i|Limelight:400|Lobster+Two:400,700,400i,700i|Lora:400,700,400i,700i|Lustria:400|Merriweather:400,700,400i,700i|Monoton:400|Montserrat:400,700|Muli:400,700,400i,700i|News+Cycle:400,700|Nixie+One:400|Nunito:400,700|Old+Standard+TT:400,700,400i,700i|Open+Sans:400,700,400i,700i|Oswald:400,700|Overlock:400,700,400i,700i|Oxygen:300,400,700|Pacifico:400|Pathway+Gothic+One:400|Paytone+One:400|Petit+Formal+Script:400|Philosopher:400,700,400i,700i|Playball:400|Playfair+Display:400,700,400i,700i|Poiret+One:400|Poppins:400,700|Questrial:400|Quicksand:400|Raleway:400,700,400i,700i|Roboto:400,700,400i,700i|Roboto+Condensed:400,700,400i,700i|Roboto+Slab:400,700|Rochester:400|Rozha+One:400|Rye:400|Satisfy:400|Share:400,700,400i,700i|Simonetta:400,700,400i,700i|Sintony:400,700&subset=all"
      />
      {/* Load 2nd batch of Latin fonts */}
      <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css?family=Six+Caps:400|Source+Sans+Pro:400,700,400i,700i|Ubuntu+Mono:400,700,400i,700i|Ultra:400|Unkempt:400,700|Unica+One:400|Varela+Round:400|Vast+Shadow:400|Vidaloka:400|Voltaire:400|VT323:400|Wire+One:400|Yellowtail:400|Fira+Sans:400,700,400i,700i|Kanit:400,700,400i,700i|Lateef:400|Amiri:400,700,400i,700i|Tajawal:400,700|Mirza:400,700|Scheherazade:400,700|Just+Another+Hand:400|Fjalla+One:400|Kaushan+Script:400|Rubik+Mono+One:400|Exo:400,700,400i,700i|Ubuntu:400,700,400i,700i|Amatic+SC:400,700|Assistant:400|Cairo:400,700|Comfortaa:400,700|Inter:400,700,400i,700i|Itim:400|Happy+Monkey:400|Heebo:400,700|Lalezar:400|Maven+Pro:400,700|Mitr:400,700|Pattaya:400|Permanent+Marker:400|Prompt:400,700,400i,700i|Rubik:400,700,400i,700i|Titillium+Web:400,700,400i,700i|Trirong:400|Baloo+Thambi:400|Barlow+Condensed:400|Cabin+Sketch:400|Courgette:400|Dancing+Script:400|Fascinate+Inline:400|Indie+Flower:400|Kalam:400|Libre+Baskerville:400|Libre+Franklin:400|Patrick+Hand:400|PT+Sans:400|PT+Sans+Narrow:400|PT+Serif:400|Raleway+Dots:400|Ribeye+Marrow:400|Shrikhand:400|Sue+Ellen+Francisco:400|Quantico:400|Palanquin:400&subset=all"
      />
      {/* Load thai fonts */}
      <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css?family=Kanit:400,700,400italic,700italic&subset=all"
      />
      {/* Load arabic fonts */}
      <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css?family=Lateef|Amiri:400,700,400italic,700italic|Tajawal:400,700|Mirza:400,700|Scheherazade:400,700&subset=all"
      />
      {/* Load cyrillic fonts */}
      <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css?family=Fira+Sans:400,700,400italic,700italic&subset=all"
      />
      {/* Load chinese fonts */}
      <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css?family=Noto+Sans+SC:400,700,400i,700i&subset=all"
      />
      {/* Load default fonts */}
      <link
      href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP&display=swap"
      rel="stylesheet"
      />
      {/* Load custom fonts */}
      <link
      rel="stylesheet"
      href="https://infograph.venngage.com/rest/customfonts/css?user_id=18187667"
      media="all"
      />
      {/* Load generic fonts */}
      <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css?family="
      media="all"
      />
      {/* Load manual generic fonts */}
      <link
      rel="stylesheet"
      href="https://infograph.venngage.com/rest/genericfonts/css"
      media="all"
      />
      {/* This script have to run at the end of this, because it calls the widget.load event bus. */}
      </>




      </div>
    );
  }
}

export default ClusterDiagram;
